webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggZD0iTTE2LjMxNCwxMC4wNDdMMTIsMTQuMzYxbC00LjMxMy00LjMxM2MtMC4yOTMtMC4yOTMtMC43NjgtMC4yOTMtMS4wNjEsMHMtMC4yOTMsMC43NjgsMCwxLjA2MWw0Ljg0NCw0Ljg0NAogICAgYzAuMTQ2LDAuMTQ2LDAuMzM4LDAuMjIsMC41MywwLjIyczAuMzg0LTAuMDczLDAuNTMtMC4yMmw0Ljg0NC00Ljg0NGMwLjI5My0wLjI5MywwLjI5My0wLjc2OCwwLTEuMDYxUzE2LjYwNyw5Ljc1NSwxNi4zMTQsMTAuMDQ3egogICAgIj48L3BhdGg+PC9zdmc+Cg=="

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// see http://vuejs-templates.github.io/webpack for documentation.
var path = __webpack_require__(345)

module.exports = {
  build: {
    env: __webpack_require__(70),
    index: path.resolve(__dirname, '../public/index.html'),
    assetsRoot: path.resolve(__dirname, '../public'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/universal-navigation/uxi-3/',
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: true,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: __webpack_require__.i({"NODE_ENV":"production"}).npm_config_report
  },
  dev: {
    env: __webpack_require__(123),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"'
}


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dummySets = function dummySets(key) {
    switch (key) {
        case 'item_authors':
            return ['Timothy Black', 'Stephaine', 'Gizi Croft', 'Rhea Leslie', 'Tiltilayo', 'Del Omlo'];
            break;
        case 'item_name':
            return ["25 Questions & Answers on Health & Human Rights", "3rd Annual Message to Congress (Franklin Roosevelt)", "3rd Epidemic: Repercussions of the Fear of AIDS", "5th International Conference on Applied Statistics", "5th International Scientific Conference of the University of Latvia", "6th Planta Europa Conference on the Conservation of Plants", "Aboriginal Food Security in Northern Canada: An Assessment of the State of Knowledge", "Abraham Lincoln's House Divided Speech", "Academic Forum Conference Proceedings", "Access to Treatment in the Private Sector Workplace", "Acheson's Address on Strategy of Freedom", "ACT Policy Reports", "Acupuncture: Review & Analysis of Reports on Controlled Clinical Trial", "Addictions Counseling", "Address Before the General Assembly of the United Nations on Peaceful Uses of Atomic Energy", "Address by John F. Kennedy", "Address Delivered Before the Senior Class in Divinity, Harvard College", "Address of the Continental Congress to the Inhabitants of Canada", "Address on Removal of Soviet Weapons from Cuba", "Address on the Middle East Crisis", "Address to President Lincoln by the Working-Men of Manchester England", "Address to the Free Persons of Color in the United States", "Address to the Nation on the Economy", "Address to the Nation on the Situation in Southeast Asia", "Address to the Nation on the War in Vietnam", "Address to the Negroes in the State of New York", "Address to the Officers of the Army", "Adherence to Long Term Therapies", "Adhesive Joints of Upper to Sole in Shoe Manufacturing from a Scientific Perspective", "Adult Literacy", "Advanced Placement (AP) Examinations", "Advanced Therapy in Hypertension & Vascular Disease", "Advocacy for Mental Health", "African Chiroptera Report", "After the Million Man March", "Age Page: Cancer Facts for People over 50 (2005)", "Age Page: Considering Surgery?", "AIDS & Men", "AIDS & Men: Taking Risks or Taking Responsibility?", "AIDS & the Law", "AIDS & the Third World", "AIDS Epidemic Update 2004", "AIDS Epidemic Update December 2003", "AIDS Epidemic Update, December 2002", "AIDS in Africa: Three Scenarios to 2025", "AIDS Reports: Investigating an Epidemic", "AirWAVES", "Alcohol Use & Sexual Risk Behaviour", "Allergen Labelling & Use of Advisory Labelling 'May Contain Traces of [Allergen]'", "Allied Academies International Conference: Proceedings of the Academy of Legal, Ethical & Regulatory Issues (ALERI)", "Anatomy of What We Value Most", "Ancient Remedies, New Disease", "Annual International Conference on Advanced Topics in Artificial Intelligence", "Annual International Conference on Advances in Biotechnology (BioTech)", "Annual International Conference on Advances in Distributed & Parallel Computing", "Annual International Conference on Bioinformatics & Computational Biology (BICB)", "Annual International Conference on Computer Games, Multimedia & Allied Technology", "Annual International Conference on Computer Science Education: Innovation & Technology", "Annual International Conference on Control, Automation & Robotics", "Annual International Conference on Geological & Earth Sciences", "Annual International Conference on Infocomm Technologies in Competitive Strategies", "Annual International Conference on Network Technologies & Communications", "Annual International Conference on Software Engineering & Applications", "Annual Journal of Electronics", "Annual Message--Part 1", "Annual Report (Alaska Division of Geological & Geophysical Surveys)", "Annual Report to Congress: The Military Power of the People's Republic of China 2005", "Anthropology in the Age of Technology", "Anti-Discrimination", "Antonymy", "Arab American News", "Arms to Fight, Arms to Protect: Women Speak Out About Conflict", "Art of Rhetoric (Institutiones Oratoriae, 1711-1741)", "Artemidorus Ephesius P.Artemid.siv Artemidorus personatus", "Asian Congress of  Applied Psychology (ACAP2014)", "Associated Press Video Collection", "Atlas Child & Adolescent Mental Health Resources", "Atlas Country Resources for Neurological Disorders 2004", "Atlas Epilepsy Care in the World", "Atlas of Gastrointestinal Surgery - Volume 1", "Atlas of Gastrointestinal Surgery - Volume 2", "Atlas of Health in Europe", "Atlas of Heart Disease & Stroke", "Atlas of Interventional Neurology", "Atlas of Pancreatic Cytopathology with Histopathologic Correlations", "Atlas: Psychiatric Education & Training Across the World 2005", "Attention to Politics & Other Facts in Students Grades 9-12", "Average Amount of Aid Received by Graduate Students with Various Types of Aid", "Average Math & Science Performance Scores of 4th- Grade Students", "Average Math & Science Performance Scores of 8th- Grade Students", "Average Mathematics Scores of Public School Students in 4th-, & 8th- Grade", "Average Performance Scores for the Arts: 1997", "Average Reading Proficiency of Students Who Read For Fun: 1984-96", "Avoiding Heart Attacks & Strokes", "Axiology: Science of Value", "Bachelor's Degrees Conferred, by Field of Study & Race-Ethnicity", "Background Notes on Countries of the World 2003", "Basic Laboratory Procedures in Clinical Bacteriology, 2nd edition", "Battle of Jutland", "Battle of Lexington, American & British Accounts", "Benjamin Harrison: Inaugural Address", "Beyond Ellen White", "Biliary Tract & Gallbladder Cancer: Diagnosis & Therapy", "Bioethics & Vulnerability", "Bioethics (9789042015173)", "Blaming Others", "Blood Cold Chain", "Bravo! Greatness of Italian Music", "Building Blocks for Tobacco Control: A Handbook", "Burden of Musculoskeletal Diseases at the Start of the Millennium", "Calculation of National Index of Public Effort to Fund Education", "Calvin Coolidge: Inaugural Address", "Canadian Taxonomy: Exploring Biodiversity, Creating Opportunity", "Cancer Drugs Industry Profile: Global", "Cancer Rehabilitation: Principles & Practice", "Cardiology Today", "Carnegie Endowment for International Peace - Reports", "Cartesian Nightmare", "Catholic Theological Society of America Proceedings", "Cervical Cancer Screening in Developing Countries", "Challenge Newsline", "Challenges & Social Responsibility in Business / Issukiai ir Socialine Atsakomybe Versle", "Checkers Speech", "Chief Seattle's 1854 Oration", "Child & Adolescent Mental Health Policies & Plans", "Children's Health & Environment: Developing Action Plans", "Children's Participation & Decision-Making in Medical Matters", "Christian Science Monitor", "Chronic Fatigue Syndrome (Routledge)", "Chronicle of Higher Education", "CIA World Fact Book", "Cicero", "Civil Unions", "Classification of Fields of Study", "Classifying Spaces of Degenerating Polarized Hodge Structures", "Climate Change & Human Health", "Clinical Adult Neurology", "Clinical Pediatric Neurology", "College & University Enrollment, by Control & Type of Institution", "College Completion", "Columbia Electronic Encyclopedia, 6th Edition", "Columbia University Press Music Forum Volume Five", "Columbia University Press Music Forum Volume Four", "Columbia University Press Music Forum Volume One", "Columbia University Press Music Forum Volume Six", "Columbia University Press Music Forum Volume Three", "Columbia University Press Music Forum Volume Two", "Compendium of Environment Statistics in the Arab Region", "Complementary Medicine in Australia & New Zealand: Its Popularisation, Legitimation, & Dilemmas", "Condition of Education, 1999: Overview", "Conference Papers -- American Association for Public Opinion Research", "Conference Papers -- American Association of Colleges of Pharmacy", "Conference Papers -- American Political Science Association", "Conference Papers -- Association for the Study of African American Life & History", "Conference Papers -- International Society on Infant Studies", "Conference Papers -- International Studies Association", "Conference Papers -- Law & Society", "Conference Papers -- Midwestern Political Science Association", "Conference Papers -- New England Political Science Association", "Conference Papers -- Northeastern Political Science Association", "Conference Papers -- Southern Political Science Association", "Conference Papers -- Western Political Science Association", "Conference Papers: International Conference on Grey Literature", "Conference Proceedings for the Biannual Congress of Psychologists of Bosnia & Herzegovina / Kongres Psihologa Bosne i Hercegovine s Medunarodnim Ucescem", "Conference Proceedings of the G20 Youth Forum 2014", "Conference Proceedings of the G20 Youth Forum 2015", "Conference Proceedings of the International Symposium on Innovative Technologies in Engineering & Science", "Conference Proceedings of the IV. International Conference of General Nurses & Workers Educating Paramedical Staff", "Conference Proceedings of the Société d'Ergonomie de Langue Française (SELF)", "Confidential Relationships", "Conflict Barometer", "Conflict of Law & Justice in the Icelandic Sagas", "CongressDaily", "Constructing Musical Healing", "Continuum Encyclopedia of Popular Music of the World", "Control of Chagas Disease", "Controlling Disease Due to Helminth Infections", "Convegni Nazionali IGF: Acta Fracturae", "Conversations with Pragmatism", "Counterinsurgency", "Coursetaking & Standards", "CQ Researcher", "Criminal Law", "Criminal Woman, the Prostitute & the Normal Woman", "Cultural Analysis, Cultural Studies & the Law: Moving Beyond Legal Realism", "Curso de Baja Talla -- Zona Pediatrica", "Cycles, Transfers & Motivic Homology Theories", "Daily Compilation of Presidential Documents", "Dangerous Protections", "Danish Council of Ethics Annual Report", "Data Protection Law for Employers: 2008", "Davis's Message to Congress", "Day of Infamy Speech", "Defects of the Confederation", "Definition of Program Areas in the National Study of Postsecondary Faculty", "Des Animaux en Santé, un Canada en Santé", "Developing Strategies to Deal with Trauma in Children", "DGGS Special Report Series", "Diet, Nutrition & the Prevention of Chronic Diseases", "Dimensions of Apeiron", "Dimensions of Health & Health Promotion", "Disability in Jewish Law", "Discovery & Characterisation of Dietary Patterns in Two Nordic Countries", "Discrete Orthogonal Polynomials", "Discrimination Law", "Distance Education in Higher Education", "Distribution of 16- to 24-year-olds, by Recency of Migration & Race, 1997", "Distribution of 1989-90 Beginning Postsecondary Students", "Distribution of 1989-90 Beginning Postsecondary Students by School Type", "Distribution of 8th- Grade Students According to Frequency of Math Exams", "Distribution of 8th- Grade Students According to Math in Pedagogy", "Distribution of Educational Expenditures of Higher Education Institutions", "Distribution of Enrollment According to Family Income", "Distribution of Enrollment in Public Elementary/Secondary Schools by Race", "Distribution of Full-Time Undergraduates Per Academic Year, 92/93 & 95/96", "Distribution of General Education Revenues of Higher Education Institutions", "Distribution of Public School Expenditures, 1994-95", "Distribution of Public School Teachers by Collaborative Activities", "Distribution of Students by Mathematics Achievement Level & Grade", "Distribution of Total Enrollment in Institutes of Higher Education by Race", "Documentos de Trabajo", "Domestic Partnership", "Drug-Acceptor Interactions", "Dynamics in One Complex Variable", "Dystonia Patient: A Guide to Practical Management", "Early Reading Activities in the Home", "Éclairer les Choix en Matière de Recherche: Indicateurs et Décisions", "EClinical Equation - Delivering the Vision", "Economic Outcomes", "Ecos", "Ecosystems & Human Well-being: Health Synthesis", "Ectogenesis", "Education Parliamentary Monitor", "Educational Attainment", "Educational Environments & Types of Disabilities", "Effective Drug Regulation", "Effets sur la Santé de l'Utilisation des Armes a Impulsions", "EHealth & Medical IT Solutions", "Electronic & Experimental Music", "Elementary & Secondary School Enrollment", "Elementary & Secondary School Enrollment: Fall 1970-2008", "Employee Relations in the Public Services", "Employment Rates for recent High School Completers Not Enrolled in College", "Encyclopedia of Sediments & Sedimentary Rocks", "Encyclopedic Reference of Cancer", "Encyclopedic Reference of Immunotoxicology", "Encyclopedic Reference of Molecular Pharmacology", "Endocrine Today", "Engineering for Rural Development - International Scientific Conference", "Enrollment Characteristics of Graduate & First-Professional Students", "Enrollment Growth", "Environmental Impact of the Consumption of Sweets, Crisps & Soft Drinks", "Epilepsy & Intensive Care Monitoring", "Epilepsy A to Z: A Concise Encyclopedia", "EPJ Web of Conferences", "Ergodic Theory of Lattice Subgroups", "Esophageal Cancer: Principles & Practice", "Essays on the Quality of Life", "Essential Speeches", "Establishing a Dialogue on Risks from Electromagnetic Fields", "État de la Science et de la Technologie au Canada", "Ethical Choices in Long-Term Care, What Does Justice Require?", "Ethics in Biomedical Research", "European Health Report 2002", "European Health Report 2005", "European Science & Technology - Conference Proceedings", "Evaluation of Certain Food Additives & Contaminants", "Evaluation of Certain Mycotoxins in Food", "Evaluation of Certain Veterinary Drug Residues in Food", "Event Dropout Rates for Those in Grades 10-12, Ages 15-24", "Evolution & Human Values", "Evolution's Eye", "Expressing Islam: Religious Life & Politics in Indonesia", "Facts, Values & Methodology", "Family Characteristics of 6- to 12-year-olds", "Family Income", "Family Law", "Family Law Update", "Family Law Update (9780735542198)", "Family Support for Learning", "Farewell Address (George Washington)", "Fathers' Involvement in Their Children's Education", "FD Roosevelt's Statement on North African Policy", "Female Field Concentration Ratio Index of Doctor's Degrees Conferred", "Female Field Concentration Ratio of Master's Degrees Conferred", "Feminisms in Development: Contradictions, Contestations & Challenges", "First Amendment", "First Inaugural Address (Eisenhower)", "First Inaugural Address (Jefferson)", "First Inaugural Address (Lincoln)", "First Inaugural Address (McKinley)", "First Inaugural Address (Nixon)", "First Inaugural Address (Reagan)", "First Inaugural Address (Washington)", "Food & Health in Europe", "Formal Axiology & Its Critics", "Forms of Hatred", "Franklin D Roosevelt: First Inaugural Address", "Franklin D Roosevelt: Fourth Inaugural Address", "Franklin D Roosevelt: Third Inaugural Address", "Freedom of Information Act: 2008", "Freedom to Live", "From the Autobiography of Frederick Douglass, 1817-1895", "Fundamentals of Verbal & Nonverbal Communication & the Biometric Issue", "Furnace of Creation Cradle of Destruction: A Journey to the Birthplace of Earthquakes, Volcanoes, & Tsunamis", "Future of Population in Asia", "Galen on Food & Diet", "General Education Revenues of Higher Education Institutions Per Student", "Genes & Morality", "Genomics & World Health", "Geologic Materials Center Data Report (Alaska Division of Geological & Geophysical Surveys)", "Geometry & Cohomology of Some Simple Shimura Varieties", "Geophysical Report", "George Washington's Second Inaugural Address", "Gestion Durable des Eaux Souterraines au Canada", "Gettysburg Address", "Give Me Liberty or Give Me Death", "Giving USA: The Annual Report on Philanthropy", "Global Action Against Cancer", "Global Status Report: Alcohol Policy", "Global Strategy for Infant & Young Child Feeding", "Global Tuberculosis Control: Surveillance, Planning, Financing", "Good evening, My Fellow Americans", "Good News", "Graduate Field of Study, by Sex & Race-Ethnicity", "Green's Function Estimates for Lattice Schrödinger Operators & Applications", "Grover Cleveland's Appeal for Gold Guarantee on Bonds", "Grover Cleveland: First Inaugural Address", "Guide to Producing National Health Accounts", "Guidelines for Drinking-Water Quality:  Third Edition - Vol. 1, Recommendations", "Guidelines for Drinking-Water Quality: Second Edition", "Guidelines for Safe Recreational Water Environments", "Guidelines for the Inpatient Treatment of Severely Malnourished Children", "Guidelines for the Management of Sexually Transmitted Infections", "Hamilton Project: Discussion Papers", "Hamilton Project: Policy Briefs", "Hamilton Project: Strategy Papers", "Handbook of Chronic Obstructive Pulmonary Disease", "Handbook of Texas Music", "Hands off the Western Hemisphere", "Harry S. Truman: Inaugural Address", "Headache Medicine: Questions & Answers", "Health & the Millennium Development Goals", "Health Effects of Conducted Energy Weapons", "Health Effects of Transport-Related Air Pollution", "Health Implications of Acrylamide in Food", "Health Systems Confront Poverty", "Health Systems Performance Assessment", "Health, Science & Ordinary Language", "Healthy Animals, Healthy Canada", "Healthy Villages", "Helminth Control in School-Age Children", "Hem/Onc Today", "Herbert Hoover: Inaugural Address", "Here for a Good Time: On the Road with Trooper-Canada's Legendary Rock Band", "Hidden Costs of AIDS", "High School Dropouts & Completions", "High School Dropouts, by Race-Ethnicity & Recency of Migration", "Higher Education Expenditures Per Student", "Higher Education Revenues Per Student", "Higher Topos Theory", "History Remembers Scientists of the 20th Century", "History Remembers Scientists of the Past", "HIV Transmission Through Breastfeeding", "HIV/AIDS Counselling, Just a Phone Call Away", "Holocaust: The Voices & Faces of History's Great Tragedy", "Honesty, Accountability & Trust: Fostering Research Integrity in Canada", "Honnêteté, Responsabilité et Confiance: Promouvoir l'Intégrité en Recherche au Canada", "Hoover's Rugged Individualism Speech", "Housing & Public Accommodations", "How to Develop & Implement a National Drug Policy", "Human Project & the Temptations of Science", "Human Resources & Training in Mental Health", "Hypoelliptic Laplacian & Ray-Singer Metrics", "I Shall Go to Korea Speech, 1952", "ICTE in Regional Development: 2005 Annual Proceedings", "ICTE in Regional Development: 2006 Annual Proceedings", "ICTE in Regional Development: 2007 Annual Proceedings", "ICTE in Regional Development: 2008 Annual Proceedings", "Ideal Homes?", "Immediate Transition from High School to College", "Immigration, Asylum, & International Human Rights", "Improving Access & Use of Psychotropic Medicines", "Inaugural Address (Buchanan)", "Inaugural Address (Carter)", "Inaugural Address (George Herbert Walker Bush)", "Inaugural Address (Kennedy)", "Inaugural Address (Lyndon Johnson)", "Inaugural Address (Pierce)", "Inaugural Address (Taylor)", "Inclusion of Students with Disabilities in the Least Restrictive Environment", "Infectious Disease News", "Infectious Diseases in Children", "Influenza Transmission & the Role of Personal Protective Respiratory Equipment: An Assessment of the Evidence", "Information on NAEP Arts Education Assessment", "Information on the International Adult Literacy Survey", "Informing Research Choices: Indicators & Judgment", "Inheriting the World: The Atlas of Children's Health & the Environment", "Initiatives on Prevention of Food Waste in the Retail & Wholesale Trades", "Injury Chart Book", "Injury Surveillance Guidelines", "Injury: A Leading Cause of the Global Burden of Disease 2000", "Innovative Care for Chronic Conditions: Building Blocks for Action", "Institutional Violence", "Instructional Methods of Postsecondary Faculty", "Instructional Practices", "Integrated Management of Cardiovascular Risk", "Integrating Emerging Technologies into Chemical Safety Assessment", "Integration of One-forms on P-adic Analytic Spaces", "Interdiction of the Delivery of Offensive Weapons to Cuba", "International Comparisons", "International Comparisons of Education Expenditures", "International Comparisons of Educational Attainment, by Age", "International Comparisons of Expenditures for Education", "International Comparisons of Student Performance in Mathematics & Science", "International Conference & Exhibition of Hydraulics & Pneumatics (HERVEX)", "International Conference e-Society", "International Conference on Applied Computing", "International Conference on Business Intelligence & Data Warehousing", "International Conference on Cloud Computing & Virtualization", "International Conference on Data Analysis, Data Quality & Metadata Management", "International Conference on e-Learning", "International Conference on eHealth", "International Conference on Enterprise Resource Planning & Supply Chain Management", "International Conference on Green Information Technology", "International Conference on Information Systems", "International Conference on Information Systems Post-Implementation & Change Management", "International Conference on Information Technology Security", "International Conference on Information Theory & Applications", "International Conference on Real-Time & Embedded Systems", "International Conference on Stem Cell Research (SCR)", "International Conference on Thermal Equipment, Renewable Energy & Rural Development", "International Multidisciplinary Scientific Conference on Social Sciences & Arts SGEM", "International Pharmacopoeia: Fourth Edition", "International Pharmacopoeia: Third Edition", "International Travel & Health 2005", "International Travel & Health 2007", "International Woodfiber Report", "Introduction to Carbon Technologies", "Iron Curtain Speech", "Islamic Connections: Muslim Societies in South & Southeast Asia", "James A. Garfield: Inaugural Address", "JARE Data Reports: Glaciology", "JARE Data Reports: Ionosphere", "JARE Data Reports: Marine Biology", "JARE Data Reports: Meteorology", "JARE Data Reports: Oceanography", "JARE Data Reports: Seismology", "JARE Data Reports: Terrestrial Biology", "JARE Data Reports: Upper Atmosphere Physics", "Jewish Genetic Disease Consortium Brochure", "John Adam's Inaugural Address", "John Hopkins University Speech", "Journal of Creation Theology & Science Series B Life Sciences", "Kangaroo Mother Care", "Keep Fit for Life", "Key Policy Issues in Long Term Care", "King William Addresses Parliament on the French question", "Kitchener's Address to the Troops", "Kodak & the Lens of Nostalgia", "Kondratieff Waves, Warfare & World Security", "L'Epidemie Silencieuse", "L'état de la R-D Industrielle au Canada", "La Vraie Cout du Sida", "Laboratory Biosafety Manual", "Language of Democracy: Political Rhetoric in the United States & Britain, 1790-1900", "Latin America in the 21st Century", "Learned Ignorance in the Medicine Bow Mountains", "Lectures on Resolution of Singularities", "Lectures on the Theory of Games", "Legal Status of Traditional Medicine & Complementary/Alternative Medicine", "Lesson of Cuba", "Liberty & Union Speech", "Library/Vendor Relationships", "Licensed Practical Nurse", "Listening for a Change: Oral Testimony & Development", "Local Environmental Health Planning: Guidance for Local & National Authorities", "Long-Term Care in Developing Countries", "Longitudinal Surveys of Australian Youth: Attitudes to School Life: Their Influences & Their Effects on Achievement & Leaving School", "Longitudinal Surveys of Australian Youth: Education Participation & Outcomes", "Longitudinal Surveys of Australian Youth: Initial Work & Education Experiences of Early School Leavers: A Comparative Study of Australia & the United", "Longitudinal Surveys of Australian Youth: Participation in Education & Training 1980-1994", "Longitudinal Surveys of Australian Youth: Student Engagement with School: Individual & School - level Influences", "Longitudinal Surveys of Australian Youth: Tertiary Entrance Performance: The Role of Student Background & School Factors", "Longitudinal Surveys of Australian Youth: Work Experience & Work Placements in Secondary School Education", "LSE Gender Institute New Working Paper Series", "Madison: Proposed Amendments to the Constitution", "Major John Andre", "Making Choices in Health: WHO Guide to Cost Effectiveness Analysis", "Making Gender", "Malaria Control in Complex Emergencies", "Managing Complications in Childbirth & Pregnancy", "Manual of Basic Techniques for a Health Laboratory", "Manual of Neonatal Surgical Intensive Care", "Manual of Pediatric Intensive Care", "Manual on the Management, Maintenance & Use of Blood Cold Chain Equipment", "Markov Processes from K. Itô's Perspective", "Marriage Project", "Maternal Mortality in 2000", "Mathematical Aspects of Nonlinear Dispersive Equations", "Mathematics Achievement Levels", "Mathematics: Overview, 1999", "Matter, Mind & Medicine", "Mayor La Guardia, Ladies & Gentlemen", "McKinley's Reciprocity Speech", "McKinley's War Message, 1898", "Meaning & Development", "Meaning of Independence: John Adams, George Washington, & Thomas Jeffferson", "Measuring Work Well-Being & Productivity in the Nordic Countries", "Medical Care of Cancer Patients", "Medical Device Regulations", "Medical Management of Adults with Neurologic Disabilities", "Medical Physics in the Baltic States", "Men of the Global South", "Mental Health Atlas: 2005", "Mental Health Context", "Mental Health Financing", "Mental Health Legislation & Human Rights", "Mental Health Policy, Plans & Programmes", "Mental Health Policy, Plans & Programmes: Updated Edition", "Mental Health: Facing the Challenges, Building Solutions", "Military (Aspen)", "Mill's Principle of Utility: A Defense of John Stuart Mill's Notorious Proof", "Minority Field Concentration Ratio at the Bachelor's Degree Level", "Minority Field Concentration Ratio of Master's Degrees Conferred", "Modern Family Law: Cases & Materials (9780735524002)", "Modular Forms & Special Cycles on Shimura Curves", "Money Changers: A Guided Tour through Global Currency Markets", "Moral Conflicts of Organ Retrieval", "Moral Status of Persons", "Multimedia Manual of Cardiothoracic Surgery", "Music & Altered States", "Mystery of Values", "NAAAS & Affiliates Conference Monographs", "National Cancer Control Programmes", "National Index of Public Effort to Fund Higher Education, 1930-96", "National Indicators of Public Investment in Education", "National Journal Daily", "Necessary Virtue: The Pragmatic Origins of Religious Liberty in New England", "Necessity & Truthful Fictions", "NeuroPsychoEconomics Conference Proceedings", "Neuroscience of Psychoactive Substance Use & Dependence", "New Science of Axiological Psychology", "New York Amsterdam News", "New York Times", "NII Technical Reports", "Nippon Steel Technical Report", "No Paradise Yet: The World's Women Face the New Century", "Nonconvulsive Status Epilepticus", "Nordic Cooperation with Russia in Education & Research", "Nordic Nutrition Recommendations 2012", "Nouvelles Technologies et Évaluation de la Sécurité Chimique", "Novel Approaches to the Diagnosis & Treatment of Posttraumatic Stress Disorder", "Nuclear Security Culture: From National Best Practices to International Standards", "Nutritional Evaluation of Lowering Consumption of Meat & Meat Products in the Nordic Context", "Ocular Surgery News Asia-Pacific", "Ocular Surgery News Europe", "Ocular Surgery News Europe/Asia-Pacific Edition", "Ocular Surgery News Latin American Edition", "On the Margins: Men Who Have Sex with Men & HIV in the Developing World", "On the Tangent Space to the Space of Algebraic Cycles on a Smooth Algebraic Variety", "Ontario Birchbark", "Oral Testimony Manual: Giving Voice", "Organization of Services for Mental Health", "Orthopaedics Today Europe", "Orthopaedics Today/International Edition", "Our Ways", "Overview of NAEP Assessments", "Palestine in Figures", "Palestinian Strategic Report 2012-2013", "Palestinian Strategic Report 2012-2013 (Arabic Language)", "Pandemic Preparedness Handbook", "Papers from the 7th Annual Conference on European Integration: Europe 2020: Towards Innovative & Inclusive Union", "Papers from the 9th Annual Conference on European Integration:  The Europe of Tomorrow: Creative, Digital, Integrated", "Part-Time Instructional Faculty & Staff at Postsecondary Institutions", "Part-time Instructional Faculty at Postsecondary Institutions", "Pathogenic Mycobacteria in Water", "Patriot Debates: Experts Debate the USA PATRIOT Act", "PCBS Annual Report", "Pediatric Rehabilitation: Principles & Practice", "Percentage Distribution According to Type Recently Read at School", "Percentage Distribution of 1989-90 Beginning Students by Highest Degree", "Percentage Distribution of 1992-93 Bachelor's Degree Recipients", "Percentage Distribution of 6- to 12-year-olds, 1972-97", "Percentage of 25- to 29-year-old High School Completers with College Degrees", "Percentage of 25- to 29-year-old High School Completers with Some College", "Percentage of 25- to 29-year-olds Who Completed High School", "Percentage of Adults Who Scored at Level 3 or Above in Document Literacy", "Percentage of High School Completers Enrolled in College by Race, 1973-97", "Percentage of High School Completers Who Were Enrolled in College, 1990-97", "Percentage of High School Seniors Using Alcohol or Drugs: 1975-98", "Percentage of High School Seniors Victimized at School: 1976-97", "Percentage of High School Seniors Victimized at School: 1994-97", "Percentage of Higher Education Institutions Offering Distance Ed Courses", "Percentage of Higher Education Institutions Offering Distance Education", "Percentage of Private Schools with Various Internet Capabilities", "Percentage of Public School Districts with Consideration of Teachers", "Percentage of Public Schools with Various Internet Capabilities", "Percentage of Students by Reading Achievement Level & Grade", "Percentage of Students Enrolled in Distance Education Courses: 1995", "Percentage of Students Scoring High in Writing Performance: 1984-96", "Percentage of Students Using Drugs During the Previous 30 Days: 1991-98", "Percentage of Students Who Used A Computer at Home: 1997", "Percentage of Students With Disabilities Ages 6-21: 1986-96", "Percentage of the Population who Completed Secondary & Higher Education", "Percentage of White Students in a Minority Student's School, 1987-96", "Percentage of White Students in Ethnic Schools Against Overall Percentages", "Percentile Distribution of Writing Performance Scores: 1984-96", "Persistence & Attainment of First-Generation Students", "Persistence & Attainment of First-Year College Dropouts", "Pesticide Residues in Food - 2001 Evaluations", "Petit et Différent: Perspective Scientifique sur les Défis Réglementaires du Monde Nanométrique", "Phases & Stages: The Terri Clark Journals", "Planning & Budgeting to Deliver Services for Mental Health", "Pocahontas (Primary Source Document)", "Pocket Book of Hospital Care for Children", "Policy Tools for Allocative Efficiency of Health Services", "Political Knowledge of Students in Grades 9-12", "Popular Music: The Key Concepts", "Positive Life", "Poverty & Health", "Preliminary Interpretive Report Series", "Preprimary Education Enrollment", "Preprimary Enrollment Rates", "President Abraham Lincoln's Last Public Address", "President Andrew Jackson's First Inaugural Address, 1829", "President Andrew Jackson's Second Inaugural Address, 1833", "President Arthur on the Indian Problem", "President Benjamin Harrison's Message on the Annexation of Hawaii", "President Bush's State of the Union Address (Herbert Walker)", "President Clinton's Inaugural Speech", "President Clinton's State of the Union Address", "President Eisenhower's State of the Union Message", "President Eisenhower's Statement on the Dispatch of U.S. Troops to Lebanon", "President Grant's Apology", "President Grover Cleveland's Message on the Venezuela Boundary Controversy", "President Harry S. Truman's Address Before a Joint Session of Congress, March 12, 1947", "President James K. Polk's Inaugural Address, 1845", "President James Madison's First Inaugural Address, 1809", "President James Madison's Second Inaugural Address, 1813", "President James Monroe's First Inaugural Address, 1817", "President James Monroe's Second Inaugural Address, 1821", "President John Quincy Adams' Inaugural Address, 1825", "President Lincoln's Proclamation on the Wade-Davis Bill", "President Martin Van Buren's Inaugural Address, 1837", "President Ronald Reagan's Speech on the Challenger Disaster", "President Rutherford B. Hayes's Veto of the Bland-Allison Act", "President Theodore Roosevelt's Annual Message", "President Ulysses S. Grant's Appeal for the Annexation of Santo Domingo", "President William Henry Harrison's Inaugural Address, 1841", "President William Howard Taft's Veto of a Literacy Test for Immigrants", "President Wilson's Appeal to the Voters", "President Wilson's First Warning to the Germans", "President Woodrow Wilson's Denunciation of the Tariff Lobby", "President's Address in Chicago", "President's Address to the Nation Announcing Steps to Limit the War in Vietnam", "Preventing Chronic Diseases: A Vital Investment", "Prevention & Management of Osteoporosis", "Primary Care Optometry News", "Primers on HIV/AIDS for the Media", "Princeton Companion to Mathematics", "Principles & Methods for the Assessment of Risk from Essential Trace Elements", "Private School Tuition", "Private Sector Responds to the Epidemic: Debswana - A Global Benchmark", "Problem of Evil", "Proceedings Conference BALTTRIB", "Proceedings of IALMS 2007 Conference: Laser Florence the Laser Medicine World", "Proceedings of the 11th Round Table", "Proceedings of the 25th NJF Congress, Nordic View to Sustainable Rural Development", "Proceedings of the 3rd World Congress on the Advancement of Scholarly Research in Science, Economics, Law & Culture", "Proceedings of the 4th World Congress on the Advancement of Scholarly Research in Science, Economics, Law & Culture", "Proceedings of the Academy of Political Science", "Proceedings of the Annual International Conferences on Geometry, Integrability & Quantization", "Proceedings of the Annual Meeting of the Idaho Academy of Science", "Proceedings of the Annual South-East European Doctoral Student Conference", "Proceedings of the ASEE Annual Conference & Exposition", "Proceedings of the Bulgarian Geological Society", "Proceedings of the Conference on Qualitative Approach & Methods in Human Sciences", "Proceedings of the Conference on Social Processes & Personality", "Proceedings of the European Conference on Ergonomics", "Proceedings of the Hawaiian Entomological Society", "Proceedings of the IAE Scientific Meetings", "Proceedings of the IASTED International Conference on Power & Energy Systems", "Proceedings of the Institute for European Studies at International University Audentes, Tallinn University of Technology; No. 5 (2009)", "Proceedings of the Institute for European Studies, International University Audentes, Tallinn University of Technology; No. 4 (2008)", "Proceedings of the Institute for European Studies, International University Audentes; No. 3", "Proceedings of the International Building & Infrastructure Technology Conference", "Proceedings of the International Conference on Civil Engineering 2011", "Proceedings of the International Conference on Information Technologies", "Proceedings of the International Conference on Systems for Automation of Engineering & Research", "Proceedings of the International Multidisciplinary Scientific GeoConference SGEM", "Proceedings of the International Scientific Conference of Daugavpils University / Daugavpils Universitates Starptautiskas Zinatniskas Konferences Materiali", "Proceedings of the International Scientific Conference People, Buildings & Environment", "Proceedings of the International Scientific Conference Perspectives in Paediatric Cardiology", "Proceedings of the International Scientific Conference: Rural Development", "Proceedings of the Islamic Pedagogical Faculty of the University of Zenica", "Proceedings of the Latvian University of Agriculture", "Proceedings of the Multidisciplinary Academic Conference", "Proceedings of the North American Academy of Liturgy", "Proceedings of the Physiological Society", "Proceedings of the Polar Libraries Colloquy", "Proceedings of the Scientific & Practical Conference Harmonius Agriculture", "Proceedings of the Scientific Conference AFASES", "Proceedings of the World Congress on Engineering & Computer Science 2010 Volume I", "Proceedings of the World Congress on Engineering & Computer Science 2010 Volume II", "Proceedings of the World Congress on Engineering & Computer Science 2012 Volume I", "Proceedings of the World Congress on Engineering & Computer Science 2012 Volume II", "Proceedings of the World Congress on Engineering 2012 Volume I", "Proceedings of the World Congress on Engineering 2012 Volume II", "Proceedings of the World Congress on Engineering 2012 Volume III", "Proceedings of the World Congress on Engineering 2013 Volume I", "Proceedings of the World Congress on Engineering 2013 Volume II", "Proceedings of the World Congress on Engineering 2013 Volume III", "Process for Developing a Common Vocabulary in the Information Security Area", "Promoting the Psychosocial Well Being of Children Following War & Terrorism", "PSAE Research Series", "Psychological Responses to the New Terrorism: A NATO-Russia Dialogue", "Psynopsis: Canada's Psychology Newspaper", "PTSD Research Quarterly", "Public Elementary & Secondary Expenditures Per Student", "Public Elementary & Secondary School Enrollment: Fall 1970-97", "Public Financial Support for Learning", "Public Funding of Religious Groups", "Public Health Response to Biological & Chemical Weapons: WHO Guidance", "Public School Districts in Evaluating Teacher Applicants", "Quality Improvement for Mental Health", "Quality of Educational Environments-Postsecondary", "Quarantine the Aggressors Speech", "Rachmaninoff: Life, Works, Recordings", "Racial & Ethnic Differences in the Transition to College", "Racial & Ethnic Distribution of College Enrollments", "Racial & Ethnic Distribution of Elementary & Secondary Students", "Racial & Ethnic Isolation of Elementary & Secondary Students", "Racial-Ethnic Differences in Achievement", "Racial-Ethnic Isolation of Students in Public Schools", "Radon Transforms & the Rigidity of the Grassmannians", "Ratio of median Annual Earnings for Salary Workers Ages 25-34", "Rational Individualism", "Ražas Svetki 'Vecauce - 2013': Lauksaimniecibas Augstakajai Izglitibai Latvija - 150: Scientific Workshop", "Reaching Out, Scaling Up", "Reading & Writing Habits of Students Outside of School", "Reading Achievement Levels", "Reading Anchor Levels", "Reading: Overview, 1999", "Recent School Dropouts", "Regional Disaster Resilience: A Guide for Developing an Action Plan", "Regulating Religion: Case Studies from Around the Globe", "Religion & Morality (978-90-5183-838-1)", "Remedial Education in Higher Education Institutions", "Renegade Regimes", "Renforcer la Capacité de Recherche du Canada: La Dimension de Genre", "Report Card for America's Infrastructure", "Report of Investigation", "Report on In-Class Variables: Fall 1987 & Fall 1992", "Report on the Global HIV/AIDS Epidemic: UNAIDS - 2004", "Reporting Diversity", "Reproductive Rights", "Requirements in Teacher Hiring", "Research for Rural Development - International Scientific Conference", "Research on Reproductive Health at WHO", "Research on Reproductive Health at WHO: Pushing the Frontiers of Knowledge: Biennial Report: 2002-2003.", "Research Report on Thailand's Coffee Industry - January 2008", "Research Report on Thailand's Shrimp Industry - January 2008", "Responding to Globalization", "Results of National Survey of State Emergency Management & Public Health Officials", "Review of Full-Time, Full-Year Graduate Students Who Worked While Enrolled", "Rheumatic Fever & Rheumatic Heart Disease", "Rising Crime in Australia", "Risk Assessments for Salmonella in Eggs & Broiler Chickens", "Road to Negro Progress", "Roosevelt's Address at Charlottesville, Virginia", "Roosevelt's Annual Message", "Roosevelt's Message on Conservation", "Roosevelt's New Nationalism Speech", "Roosevelt, the Great Depression, & the Economics of Recovery", "Rough Dialectics", "Royal Zoological Society of New South Wales Forum Proceedings - Pest & Guest", "Royal Zoological Society of New South Wales Forum Proceedings - Too Close for Comfort", "Rutherford B. Hayes: Inaugural Address", "Sacco's & Vanzetti's Statements to the Court", "Safe Abortion", "Safe Piped Water: Managing Microbial Water Quality in Piped Distribution Systems", "Salaries of Teachers", "Saving Possibilities", "Science Anchor Levels", "Science in Culture (978-90-420-2136-5)", "Science: Overview, 1999", "Sciences of Carbon Materials", "Scientific Research Activity of the Institute of Ecology - Annual Report", "Scratching the Surface of Bioethics", "Second Inaugural Address (Cleveland)", "Second Inaugural Address (Eisenhower)", "Second Inaugural Address (F. Roosevelt)", "Second Inaugural Address (Jefferson)", "Second Inaugural Address (Lincoln)", "Second Inaugural Address (McKinley)", "Second Inaugural Address (Nixon)", "Second Inaugural Address (Reagan)", "Sécurité Alimentaire des Populations Autochtones dans le Nord du Canada: Évaluation de l'État des Connaissances", "Selection & Use of Essential Medicines", "Semiclassical Soliton Ensembles for the Focusing Nonlinear Schrödinger Equation", "Senate Selects POW-MIA Affairs Report", "Sex Determination in Plants", "Sharing Knowledge Across the Mediterranean Area", "SIDA et Tiers Monde", "SIDA y Tercer Mundo", "SIDA/AIDS E O Tercero Mundo", "Signposts on the Superhighway: African Gender", "Silent Epidemic: HIV/AIDS & Men Who Have Sex with Men in the Developing World", "Singapore: The Unexpected Nation", "Single Tax Platform of Henry George, 1886", "Small is Different: A Science Perspective on the Regulatory Challenges of the Nanoscale", "Social Capital", "Social Capital Stories", "Social Determinants of Health: The Solid Facts", "Solutions in Dioxin & Mercury Removal", "South Dakota Kids Count Factbook: State & County Profiles of Child Well-Being", "Southeastern Biology", "Special Message to Congress Proposing a Nationwide War on the Sources of Poverty", "Special Message to the Congress on Civil Rights", "Special Message to the Congress Recommending Point 4 Legislation", "Special Message to the Congress Urging Legislation for Industrial Peace", "Speech Against the Writs of Assistance", "Speech by George Wallace on the 1964 Civil Rights Act", "Speech on the Stamp Act", "Speech Resisting Colonial Expansion", "Speech to the Virginia Commisioners at the Treaty of Lancaster", "Spherical CR Geometry & Dehn Surgery", "Spine: Rehabilitation Medicine Quick Reference", "Springer Index of Viruses", "State of Industrial R&D in Canada", "State of Science & Technology in Canada", "State of the Union Address (Bill Clinton)", "State of the World's Vaccines & Immunization. Revised Edition, 2003", "Statement by the President Announcing Recognition of the State of Israel", "Statement by the President on the Hydrogen Bomb", "Statement by the President on the Situation in Korea", "Statement by the President Regarding Occurrences at Central High School in Little Rock", "Statement on Opening Frontiers to War Victims & Justice for War Crimes", "Statement on Soviet Decision to Remove Cuban Missiles", "Statement on the Developments at Little Rock", "Strategy for Homeland Defense & Civil Support", "Strategy of Massive Retaliation", "Strengthening Canada's Research Capacity: The Gender Dimension", "Structural Adjustment: The SAPRI Report", "Structure of Affine Buildings", "Student Alcohol & Drug Use", "Student Computer Use", "Student Financing of Graduate & First-Professional Education", "Student Victimization at School", "Students on Their Way to Science", "Students Who Reported it Would be Easy to Get Drugs: 1992-98", "Supreme Court Cases: Re-establishing Order (1864-1930)", "Supreme Court Cases: The Dynamic Court (1930-1999)", "Supreme Court Cases: The Early Court (1790-1864)", "Supreme Court Cases: The Twenty-first Century (2000 - Present)", "Surgical Care at the District Hospital", "Survey of the Economic & Social Developments in the Arab Region", "Sustainable Management of Groundwater in Canada", "Taft's Message on Canadian Reciprocity", "Taking Religious Claims Seriously", "Talking about Health", "Tariff Message, Grover Cleveland, 1887", "Tariff Revision under Wilson: Wilson's Address to Congress", "Taxonomie Canadienne: Explorer la Biodiversité, Créer des Possibilités", "TB/HIV: A Clinical Manual", "Teacher Preparedness", "Teachers' Feelings of Preparedness", "Teachers' Participation in Collaborative Activities", "Teaching Workload & Research Production of Full-Time Postsecondary Faculty", "Teaching Workload of Full-Time Postsecondary Faculty", "Temporal Assessment of Diagnostic Materials from the Piñon Canyon Maneuver Site", "Terrorist Threats to Food", "Theodore Roosevelt: Inaugural Address", "Theological Research Exchange Network (TREN): Theses & Dissertations", "Thomas Jefferson's Message on the Burr Conspiracy", "Topology & Groupoids", "Total & Full-Time Equivalent Enrollment in Higher Education", "Toxicological Evaluation of Certain Veterinary Drug Residues in Food", "Trade Secrets of Business Disposals", "Trading Women's Health & Rights: Trade Liberalisation & Reproductive Health in Developing Economies", "Transition to College", "Transmission du Virus de la Grippe et la Contribution de l'Équipement de Protection Respiratoire Individuelle: Évaluation des Données Disponibles", "Transputer Applications & Systems '95", "Trends in Science Performance of 9-, 13-, & 17-year olds", "Trends in Student Borrowing: Subsidized & Unsubsidized Loans", "Trends in Student Borrowing: Subsidized & Unsubsidized Stafford Loans", "Triangulated Categories", "Tripla Ameaca", "Triple Jeopardy: Women & AIDS", "Triple Riesgo: Mujeres y Sida", "True History of the So-Called Artemidorus Papyrus", "True History of the So-Called Artemidorus Papyrus - Supplement", "True Interest of America Impartially Stated", "Truman Announces Hydrogen Bomb Program", "Tuition & Enrollment in Private Schools", "Twisted L-Functions & Monodromy", "U.S. Naval Institute Proceedings", "Ultimate Review for the Neurology Boards, Second Edition", "Ulysses S. Grant: First Inaugural Address", "Ulysses S. Grant: Second Inaugural Address", "Undelivered Dallas Speech", "United States Country Monitor", "Urbanicity Variable in the National Household Education Survey", "USA Today", "Uses of Computers for Mathematics Instruction", "Utilitarian General Theory of Value", "Value, Obligation & Meta-Ethics", "ValuemetricsA: The Science of Personal & Professional Ethics", "Virtual Reality Technology", "Vision for the Canadian Arctic Research Initiative: Assessing Opportunities", "Vision pour l'Initiative Canadienne de Recherche dans l'Arctique: Évaluation des Possibilités", "Vitamin & Mineral Requirements in Human Nutrition", "Wall Street Journal (Online)", "Wall Street Journal - Eastern Edition", "Wall Street Journal - Online Edition", "War Message to Congress", "Warren Commission Report, 1964", "Warren G. Harding: Inaugural Address", "Waste: The Social Context (2005)", "Water for Life: Making it Happen", "Water Recreation & Disease", "Weekly Compilation of Presidential Documents", "What Caused the Big Bang?", "White Men on Race", "WHO Expert Committee on Biological Standardization", "WHO Expert Committee on Biological Standardization: Fifty-Second Report", "WHO Expert Committee on Specifications for Pharmaceutical Preparations (2003)", "WHO Expert Committee on Specifications for Pharmaceutical Preparations (2005)", "WHO Expert Consultation on Rabies", "WHO Guidelines on Good Agricultural & Collection Practices (GACP) for Medicinal Plants", "WHO Manual of Diagnostic Imaging: Radiographic Technique & Projections", "WHO Manual of Diagnostic Imaging: Radiography of the Musculoskeletal System", "WHO Resource Book on Mental Health, Human Rights & Legislation", "WHO-CVD Risk Management Package for Low & Medium Resource Settings", "WHO-UNAIDS Guidelines for Standard HIV Isolation & Characterization Procedures", "Wie kann das ein Artemidor- Papyrus sein? Ma come fa a essere un papiro di Artemidoro?", "Will Fair Use Survive? Free Expression in the Age of Copyright Control", "William Howard Taft: Inaugural Address", "Wilson's Panama Canal Tolls Message", "Wilson's Special Message on Mexican Relations", "Woman in the Body", "Women, Men, & Spiritual Power", "Woodrow Wilson: First Inaugural Address", "Woodrow Wilson: Second Inaugural Address", "Work Values: Education, Organization & Religious Concerns", "Working Paper Series (Federal Reserve Bank of Atlanta)", "Working Papers in African Studies", "World Congress on Engineering 2007 (Volume 1)", "World Congress on Engineering 2007 (Volume 2)", "World Congress on Engineering 2009 (Volume 1)", "World Congress on Engineering 2009 (Volume 2)", "World Health Report 2003", "World Health Report 2005", "World Health Statistics 2005", "World Politics Review (Selective Content)", "World Report on Road Traffic Injury Prevention", "Writing Anchor Levels", "Youth & Schools"];
            break;
        case 'vendor':
            return ['Baker & Taylor', 'ComiXology', 'EBSCO', 'Enki (Califa)', 'Biblioboard', 'Bolinda / BorrowBox'];
            break;
        case 'publisher':
            return ['ACME Publishing Group'];
            break;
        case 'resource_type':
            return ['Book', 'CD'];
            break;
        case 'package_title':
            return ['Academic Search Alumni Edition', "Cyberlibris e-books: Sciences de l'Ingénieur (Couperin)", 'Cyberlibris: Collection Ebooks UNR Rhône Alpes', 'EBSCO eBooks', 'Elsevier ScienceDirect 2015 (Biblioson)', 'MyiLibrary', 'ProQuest Ebook Central', 'ProQuest Ebook Library (EBL)', 'Safari Basic Tech Library', 'Safari Premium Library', 'Safari Tech Books Online', 'Scholar Vox', 'Scholar Vox Sciences', "Scholarvox Université — Sciences de l'ingénieur", 'ScienceDirect eBooks — Freedom Collection 2016', 'ScienceDirect eBooks — Freedom Collection 2017', 'ScienceDirect eBooks — Social Sciences 2014', 'ScienceDirect eBooks (MINCYT)', 'ScienceDirect eBooks Collection', 'ScienceDirect eBooks Collection 2014'];
            break;
        case 'yes_no':
            return ['Yes', 'No'];
            break;
        case 'patron_groups':
            return ['Faculty', 'Staff', 'Undergrad', 'Graduate'];
            break;
        case 'item_status':
            return ['Checked out - Recalled', 'Checked out', 'Checked out - Hold'];
            break;
        case 'locations':
            return ['Johnson East Library'];
            break;
        case 'sources':
            return ['Discovery'];
            break;
        case 'desks':
            return ['Main - Circ Desk 4', 'Main - Circ Desk 2', 'Main - Circ Desk 1', '-'];
            break;
        case 'fee_type':
            return ['Damaged item fee', 'Locker fee', 'Printing fee', 'Digitization fee', 'Missing SD card'];
            break;
        case 'fee_status':
            return ['Paid', 'Unpaid'];
            break;
        case 'loan_actions':
            return ['Recalled', 'Renewed', 'Checked out'];
            break;
        case 'fee_actions':
            return ['Edited fee/fine', 'Partial waive', 'Payment - Check', 'Payment - Credit card'];
            break;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (dummySets);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chance__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dummy_dummy_data__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);


/**
 * Dummy content generator
 */



var chance = new __WEBPACK_IMPORTED_MODULE_3_chance___default.a();



var assetsSubDirectory =  true ? __WEBPACK_IMPORTED_MODULE_5__config___default.a.build.assetsSubDirectory : config.dev.assetsSubDirectory;

var generator = {

    getSet: __WEBPACK_IMPORTED_MODULE_4__dummy_dummy_data__["a" /* default */],

    // Random string
    randomStringFromSet: function randomStringFromSet(key) {
        return __WEBPACK_IMPORTED_MODULE_2_underscore___default.a.sample(this.getSet(key));
    },


    // Get x amount of random items from set
    getRandomItemsFromSet: function getRandomItemsFromSet(key) {
        var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

        var set = this.getSet(key);
        var shuffled = set.sort(function () {
            return .5 - Math.random();
        });
        return shuffled.slice(0, count);
    },


    // Get date
    getDate: function getDate() {
        return '' + chance.date({ string: true });
    },


    // Get name
    getName: function getName() {
        return '' + chance.name();
    },


    // Get name
    getStatus: function getStatus() {
        return __WEBPACK_IMPORTED_MODULE_2_underscore___default.a.sample(['Active', 'Inactive']);
    },


    // Get random number
    getRandomNumber: function getRandomNumber() {
        var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        return chance.natural({ min: min, max: max });
    },


    // Get profile picture url
    getProfilePictureUrl: function getProfilePictureUrl(gender, pictureId) {
        return assetsSubDirectory + '/images/profile-pictures/' + gender + '/image-' + pictureId + '.png';
    },
    randomString: function randomString() {
        return '' + chance.natural() + chance.syllable();
    },


    // Generate random pane content
    randomContentOfType: function randomContentOfType(key) {
        var includes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var defaults = {
            id: '' + chance.natural() + chance.syllable(),
            includes: includes
        };
        switch (key) {

            // Order
            case 'order':
                var order = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'order',
                    view: 'orders-view',
                    owner: 'orders',
                    name: this.randomStringFromSet('item_name'),
                    publisher: 'ACME Publishing Group',
                    vendor: this.randomStringFromSet('vendor'),
                    orderId: chance.natural({ min: 10001, max: 99999 }),
                    created: this.getDate(),
                    sent: this.getDate(),
                    user: this.getName(),
                    price: chance.dollar({ max: 1000 }),
                    items: chance.natural({ min: 1, max: 20 })
                }, defaults);

                order['breadcrumb'] = 'Order #' + order.orderId;
                order['sub'] = order.items + ' items ordered from ' + order.publisher;
                order['title'] = '' + order.orderId;
                order['headline'] = 'Order No. ' + order.orderId;

                return order;
                break;

            // Item
            case 'item':
                var item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'item',
                    owner: 'items',
                    view: 'items-view',

                    name: this.randomStringFromSet('item_name'),
                    status: 'Available',
                    barcode: chance.natural({ min: 1000000000000, max: 9999999999999 }),
                    loan_type_permanent: 'Short-term loan',
                    loan_type_temporary: 'Short-term loan',
                    location_type_permanent: 'Short-term loan',
                    location_type_temporary: 'Short-term loan',
                    material_type: this.randomStringFromSet('resource_type'),
                    call_number: chance.ssn(),
                    language: 'English',

                    instanceCount: this.getRandomNumber(1, 3)

                }, defaults);

                item['title'] = item.name + ' - ' + item.material_type + ' - ' + item.language;
                item['sub'] = item.call_number + ' - ' + item.barcode;
                item['breadcrumb'] = 'Item ' + item.barcode;

                return item;
                break;

            // Instance
            case 'instance':
                var instance = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'instance',
                    owner: 'instances',
                    view: 'instances-view',

                    name: this.randomStringFromSet('item_name'),
                    subjects: ['Libray & information Science', 'Language arts and disciplines / Library', 'Information Science / General', 'Language arts & disciplines', 'Information science / digital & Online Resources'],
                    identifiers: ['ISBN: 978-1-7848383-4222-2 (paper)', '978-1-223-23-791-0 (cloth)'],
                    source: 'Local: Marc',
                    edition: '1st Edition',
                    publisher: this.randomStringFromSet('publisher'),
                    publication_date: this.getDate(),
                    resource_type: this.randomStringFromSet('resource_type'),
                    instance_id: chance.natural({ min: 10001, max: 99999 }),

                    packageCount: this.getRandomNumber(1, 3)

                }, defaults);

                instance['title'] = '' + instance.name;
                instance['breadcrumb'] = 'Instance #' + instance.instance_id;

                return instance;
                break;

            // Package
            case 'package':
                var _package = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'package',
                    owner: 'packages',
                    view: 'packages-view',
                    name: this.randomStringFromSet('package_title'),
                    holdings: this.randomStringFromSet('yes_no'),
                    source: 'External KB',
                    package_type: 'Aggregated Full-Text',
                    hide_all_titles: this.randomStringFromSet('yes_no'),
                    allow_ebsco: this.randomStringFromSet('yes_no'),
                    vendor: this.randomStringFromSet('vendor'),
                    proxy_server: 'Inherited',
                    titles: chance.natural({ min: 1001, max: 4000 }),
                    package_id: chance.fbid(),
                    instanceCount: this.getRandomNumber(10, 20)

                }, defaults);
                _package['title'] = '' + _package.name;
                _package['sub'] = '#' + _package.package_id;
                _package['breadcrumb'] = '' + _package.name;

                return _package;
                break;

            // User
            case 'user':
                var user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'user',
                    owner: 'users',
                    view: 'users-view',

                    profilePictureId: chance.integer({ min: 1, max: 66 }), // We have 66 predefined profile pictures
                    gender: chance.gender().toLowerCase(),
                    status: this.getStatus(),
                    patron_group: this.randomStringFromSet('patron_groups'),
                    loan_count: this.getRandomNumber(3, 10),
                    expiration_date: this.getDate()

                }, defaults);

                user['profilePictureUrl'] = this.getProfilePictureUrl(user.gender, user.profilePictureId);
                user['name'] = chance.name({ gender: user.gender });
                user['firstname'] = user['name'].split(' ')[0];
                user['lastname'] = user['name'].split(' ')[1];
                user['title'] = user.lastname + ', ' + user.firstname;
                user['breadcrumb'] = user.name;
                user['username'] = ('' + user.firstname + user.lastname).toLowerCase();

                return user;
                break;

            // Loan
            case 'loan':
                var loan = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'loan',
                    owner: 'users',
                    view: 'loans-view',

                    loan_id: this.getRandomNumber(5000, 10000),
                    item_type: this.randomStringFromSet('resource_type'),
                    item_name: this.randomStringFromSet('item_name'),
                    item_status: this.randomStringFromSet('item_status'),
                    loan_policy: __WEBPACK_IMPORTED_MODULE_2_underscore___default.a.sample(['14 days', '7 days', '30 days']),
                    loan_date: this.getDate(),
                    due_date: this.getDate(),
                    return_date: this.getDate(),
                    borrower: this.getName(),
                    authors: this.getRandomItemsFromSet('item_authors', 3),
                    barcode: chance.natural({ min: 1000000000000, max: 9999999999999 }),
                    fee_fine: chance.floating({ min: 5, max: 100, fixed: 2 }),
                    call_number: this.randomString(),
                    location: this.randomStringFromSet('locations'),
                    renewal_count: this.getRandomNumber(),
                    request_queue: this.getRandomNumber(),
                    claim_returned: '-',
                    lost: '-'
                }, defaults);

                loan['breadcrumb'] = 'Loan #' + loan.loan_id;

                return loan;
                break;

            // Loan actions
            case 'loan_action':
                var loan_action = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'loan_action',
                    // owner: 'users',
                    // view: 'loans-view',

                    action_date: this.getDate(),
                    action: this.randomStringFromSet('loan_actions'),
                    desk: this.randomStringFromSet('desks'),
                    source: this.randomStringFromSet('sources'),
                    due_date: this.getDate(),
                    item_status: this.randomStringFromSet('item_status')
                }, defaults);

                return loan_action;
                break;

            // Fee's 'n' fines
            case 'fee':
                var fee = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'fee',
                    owner: 'users',
                    // view: 'loans-view',
                    due_date: this.getDate(),
                    charge_date: this.getDate(),
                    amount: chance.floating({ min: 5, max: 100, fixed: 2 }),
                    fee_id: this.getRandomNumber(5000, 10000),
                    fee_type: this.randomStringFromSet('fee_type'),
                    fee_owner: this.randomStringFromSet('locations'),
                    fee_status: this.randomStringFromSet('fee_status'),
                    item_name: this.randomStringFromSet('item_name'),
                    item_type: this.randomStringFromSet('resource_type'),
                    barcode: chance.natural({ min: 1000000000000, max: 9999999999999 }),
                    call_number: this.randomString()
                }, defaults);

                fee['charged'] = fee.amount;
                fee['remaining'] = (fee['charged'] - chance.floating({ min: 0, max: fee['charged'] - 4, fixed: 2 })).toFixed(2);
                fee['breadcrumb'] = 'Fee/fine ' + fee.fee_id;
                return fee;
                break;

            // Fee actions
            case 'fee_action':
                var fee_action = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    type: 'fee_action',
                    // owner: 'users',
                    // view: 'loans-view',

                    action_date: this.getDate(),
                    action: this.randomStringFromSet('fee_actions'),
                    balance: chance.floating({ min: 5, max: 100, fixed: 2 }),
                    transaction_number: chance.natural({ min: 1000000000000, max: 9999999999999 }),
                    created_at: this.randomStringFromSet('locations'),
                    source: this.getName(),
                    notes: chance.paragraph({ sentences: 1 })
                }, defaults);

                return fee_action;
                break;

            default:
                console.warn('Collection with key', key, ' not found!');
                return [];
        }
    },


    // Generate random list of items
    randomList: function randomList(key, count, includes) {
        var _this = this;

        if (typeof count !== 'number') {
            console.warn('No count was supplied to generator.randomList(). Defaults to 5.');
            return 5;
        }
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Array(count))).map(function () {
            return _this.randomContentOfType(key, includes);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (generator);

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/**
 * Import all universal components
 */


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-icon-button', __webpack_require__(386));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-icon', __webpack_require__(385));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pane-preview-container', __webpack_require__(393));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pane-header', __webpack_require__(391));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pane-content-with-sidebar', __webpack_require__(390));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pane-header-search', __webpack_require__(392));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pane-content', __webpack_require__(389));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('order-details', __webpack_require__(388));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pane-section', __webpack_require__(394));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('inventory-block', __webpack_require__(387));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('skeleton-lines', __webpack_require__(395));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-button', __webpack_require__(396));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-link', __webpack_require__(403));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-checklist', __webpack_require__(397));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-search-field', __webpack_require__(406));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-data-list', __webpack_require__(398));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-icon', __webpack_require__(402));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-scrollable-container', __webpack_require__(405));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-details', __webpack_require__(399));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-headline', __webpack_require__(401));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-tab-list', __webpack_require__(407));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-padding', __webpack_require__(404));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ui-dropdown', __webpack_require__(400));

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var merge = __webpack_require__(470)
var prodEnv = __webpack_require__(70)

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ViewContainer__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ViewContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ViewContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Breadcrumbs__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AppSwitcher__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AppSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AppSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_generator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_keymaster__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_keymaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_keymaster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_AppToast__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_app_AppToast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_app_AppToast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ModeSwitcher__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ModeSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ModeSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_AppTabs__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_app_AppTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_app_AppTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__config__);







var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var assetsPublicPath =  true ? __WEBPACK_IMPORTED_MODULE_15__config___default.a.build.assetsPublicPath : config.dev.assetsPublicPath;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    mounted: function mounted() {
        // Add initial app state to app state history
        this.addInitialAppStateToHistory();

        console.groupCollapsed('App loaded');
        console.log('This:', this);
        console.log('Current App:', this.currentApp);
        console.log('Tools:', this.tools);
        console.log('Mode:', this.currentMode);
        console.groupEnd();
    },

    components: {
        ViewContainer: __WEBPACK_IMPORTED_MODULE_7__components_ViewContainer___default.a,
        'app-breadcrumbs': __WEBPACK_IMPORTED_MODULE_8__components_Breadcrumbs___default.a,
        'app-context-switcher': __WEBPACK_IMPORTED_MODULE_9__components_AppSwitcher___default.a,
        'app-toasts': __WEBPACK_IMPORTED_MODULE_12__components_app_AppToast___default.a,
        ModeSwitcher: __WEBPACK_IMPORTED_MODULE_13__components_ModeSwitcher___default.a,
        AppTabs: __WEBPACK_IMPORTED_MODULE_14__components_app_AppTabs___default.a
    },
    data: function data() {
        return {
            transitionId: null,
            showAppSwitcher: false,
            showDebugger: false,
            hideBackButton: true,
            toasts: [],
            currentShowAllBehavior: 'full_list',
            showAllBehaviors: [{
                key: 'full_list',
                label: 'Full list',
                image: false
            }, {
                key: 'owner_home',
                label: 'Home with search',
                image: false
            }],
            currentSwitcherLayout: 'boxes',
            switcherLayouts: [{
                key: 'boxes',
                label: 'Boxes',
                image: false
            }, {
                key: 'tabs',
                label: 'Tabs',
                image: false
            }],
            currentBackButtonBehavior: 'show_back',
            backButtonBehaviors: [{
                key: 'show_back',
                label: 'Back',
                image: assetsPublicPath + 'static/images/close-icon.svg'
            }, {
                key: 'show_close',
                label: 'Close',
                image: assetsPublicPath + 'static/images/back-icon.svg'
            }, {
                key: 'dont_show',
                label: 'No button',
                image: false
            }],
            currentAltClickMode: '',
            altClickModes: [{
                key: '',
                label: 'Nothing',
                image: false
            }, {
                key: 'OWNER_APP_CLEAR',
                label: 'Mode A',
                image: false
            }, {
                key: 'SAME_APP_ADD',
                label: 'Mode B',
                image: false
            }, {
                key: 'OWNER_APP_NEW_CONTEXT',
                label: 'Mode C',
                image: false
            }],

            currentMode: 'OWNER_APP_CLEAR',
            availableModes: [{
                key: 'OWNER_APP_CLEAR',
                label: 'A. Clear breadcrumbs and add (owner app)',
                description: '',
                image: assetsPublicPath + 'static/images/mode-4.svg'
            }, {
                key: 'SAME_APP_ADD',
                label: 'B. Add to breadcrumbs (same app)',
                description: '',
                image: assetsPublicPath + 'static/images/mode-1.svg'
            },
            // 2
            // {
            //     key: 'OWNER_APP_ADD',
            //     label: 'B. Add to breadcrumbs (owner app)',
            //     description: '',
            //     image: assetsPublicPath + 'static/images/mode-2.svg',
            // },
            // 3
            {
                key: 'OWNER_APP_NEW_CONTEXT',
                label: 'C. Add new context (owner app)',
                description: '',
                image: assetsPublicPath + 'static/images/mode-3.svg'
            }],
            currentRouteKey: 'users',
            routes: {
                users: {
                    key: 'user',
                    dropdown: false,
                    panes: {
                        search: false,
                        preview: false
                    },
                    icon: __webpack_require__(366),
                    name: 'Users',
                    appState: [{
                        title: 'Home',
                        key: 'users-view',
                        owner: 'users',
                        data: {
                            pane: __WEBPACK_IMPORTED_MODULE_10__helpers_generator__["a" /* default */].randomContentOfType('user')
                        }
                    }],
                    appStateHistory: [],
                    stackId: function stackId() {
                        return _this.randomId();
                    }
                },
                packages: {
                    key: 'package',
                    dropdown: false,
                    panes: {
                        search: false,
                        preview: false
                    },
                    icon: __webpack_require__(365),
                    name: 'Packages',
                    appState: [{
                        title: 'Home',
                        key: 'packages-view',
                        owner: 'packages',
                        data: {
                            pane: __WEBPACK_IMPORTED_MODULE_10__helpers_generator__["a" /* default */].randomContentOfType('package')
                        }
                    }],
                    appStateHistory: [],
                    stackId: function stackId() {
                        return _this.randomId();
                    }
                },
                orders: {
                    key: 'order',
                    dropdown: false,
                    panes: {
                        search: false,
                        preview: false
                    },
                    icon: __webpack_require__(364),
                    name: 'Orders',
                    appState: [{
                        title: 'Home',
                        key: 'orders-view',
                        owner: 'orders',
                        data: {
                            pane: __WEBPACK_IMPORTED_MODULE_10__helpers_generator__["a" /* default */].randomContentOfType('order')
                        }
                    }],
                    appStateHistory: [],
                    stackId: null
                },
                instances: {
                    key: 'instance',
                    dropdown: false,
                    panes: {
                        search: false,
                        preview: false
                    },
                    icon: __webpack_require__(362),
                    name: 'Instances',
                    appState: [{
                        title: 'Home',
                        key: 'instances-view',
                        owner: 'instances',
                        data: {
                            pane: __WEBPACK_IMPORTED_MODULE_10__helpers_generator__["a" /* default */].randomContentOfType('instance')
                        }
                    }],
                    appStateHistory: [],
                    stackId: function stackId() {
                        return _this.randomId();
                    }
                },
                items: {
                    key: 'item',
                    dropdown: false,
                    panes: {
                        search: false,
                        preview: false
                    },
                    icon: __webpack_require__(363),
                    name: 'Items',
                    appState: [{
                        title: 'Home',
                        key: 'items-view',
                        owner: 'items',
                        data: {
                            pane: __WEBPACK_IMPORTED_MODULE_10__helpers_generator__["a" /* default */].randomContentOfType('item')
                        }
                    }],
                    appStateHistory: [],
                    stackId: function stackId() {
                        return _this.randomId();
                    }
                }
                // finances: {
                //     icon: require('./assets/icons/app-icon-finances.png'),
                //     name: 'Finances',
                // },
                // users: {
                //     icon: require('./assets/icons/app-icon-users.png'),
                //     name: 'Users',
                // },
                // contacts: {
                //     icon: require('./assets/icons/app-icon-contacts.png'),
                //     name: 'Contacts',
                // },
                // checkout: {
                //     icon: require('./assets/icons/app-icon-checkout.png'),
                //     name: 'Checkout',
                // },
            }
        };
    },
    computed: {
        appSwitcherItems: function appSwitcherItems() {
            var currentApp = this.currentApp;

            return currentApp.appStateHistory;
        },
        showContextSwitcherButton: function showContextSwitcherButton() {
            return this.tools.modifiers.currentMode === 'OWNER_APP_NEW_CONTEXT' || this.tools.modifiers.currentMode === 'MODIFIER_1';
        },
        breadcrumbs: function breadcrumbs() {
            var currentRouteKey = this.currentRouteKey,
                routes = this.routes;

            var route = routes[currentRouteKey];
            var breadcrumbs = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(route.appState));
            return breadcrumbs;
        },
        breadcrumbsWithDropdown: function breadcrumbsWithDropdown() {
            var breadcrumbs = this.breadcrumbs;

            var MAX_ITEMS = 6;
            var BEGIN_DROPDOWN_AFTER = 2;
            var count = breadcrumbs.length;
            var breadcrumbsWithIndexes = breadcrumbs.map(function (b, i) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(b, { i: i });
            });

            // No dropdown
            if (count <= MAX_ITEMS) {
                return breadcrumbsWithIndexes;
            }

            var spliced = breadcrumbsWithIndexes.splice(BEGIN_DROPDOWN_AFTER - 1, breadcrumbs.length - 2);
            breadcrumbsWithIndexes.splice(BEGIN_DROPDOWN_AFTER - 1, 0, spliced);

            return breadcrumbsWithIndexes;
        },

        currentApp: {
            get: function get() {
                return this.routes[this.currentRouteKey];
            },
            set: function set(newValue) {
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.routes, this.currentRouteKey, newValue);
            }
        },
        currentView: {
            get: function get() {
                var appState = this.currentApp.appState;
                return appState[appState.length - 1];
            }
        },

        // Get app icons
        appIcons: function appIcons() {
            var routes = this.routes;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(routes).reduce(function (a, b) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(a, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, routes[b].key, routes[b].icon));
            }, {});
        },


        // Handy tools that can be passed down into components
        tools: function tools() {
            var currentShowAllBehavior = this.currentShowAllBehavior,
                transitionId = this.transitionId,
                presetToKey = this.presetToKey,
                currentBackButtonBehavior = this.currentBackButtonBehavior,
                toggleContextSwitcher = this.toggleContextSwitcher,
                switchContext = this.switchContext,
                replaceAppState = this.replaceAppState,
                closePreviewPane = this.closePreviewPane,
                togglePane = this.togglePane,
                currentApp = this.currentApp,
                appIcons = this.appIcons,
                changeRoute = this.changeRoute,
                changeView = this.changeView,
                goBack = this.goBack,
                currentView = this.currentView,
                currentRouteKey = this.currentRouteKey,
                updateCurrentViewData = this.updateCurrentViewData,
                replaceCurrentViewData = this.replaceCurrentViewData,
                currentMode = this.currentMode,
                hideBackButton = this.hideBackButton,
                routes = this.routes;

            return {
                transitionId: transitionId,
                currentApp: currentApp,
                currentRouteKey: currentRouteKey,
                currentPaneKey: this.currentView.data && this.currentView.data.pane ? this.currentView.data.pane.type : false,
                navigate: {
                    changeRoute: changeRoute,
                    changeView: changeView,
                    goBack: goBack
                },
                helpers: {
                    presetToKey: presetToKey
                },
                actions: {
                    togglePane: togglePane,
                    closePreviewPane: closePreviewPane,
                    replaceAppState: replaceAppState,
                    switchContext: switchContext,
                    toggleContextSwitcher: toggleContextSwitcher
                },
                modifiers: {
                    hideBackButton: hideBackButton,
                    currentMode: currentMode,
                    currentBackButtonBehavior: currentBackButtonBehavior,
                    currentShowAllBehavior: currentShowAllBehavior
                },
                currentView: currentView,
                changeView: changeView,
                randomizer: new Chance(),
                generator: __WEBPACK_IMPORTED_MODULE_10__helpers_generator__["a" /* default */],
                updateCurrentViewData: updateCurrentViewData,
                replaceCurrentViewData: replaceCurrentViewData,
                routes: routes,
                appIcons: appIcons
            };
        }
    },
    methods: {
        presetToKey: function presetToKey(preset) {
            var routes = this.routes;
            var presetToKeyIndex = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(routes).reduce(function (a, b) {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(a, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, routes[b].key, b));
            }, {});

            if (typeof presetToKeyIndex !== 'undefined') {
                return presetToKeyIndex[preset];
            } else {
                console.warn('No key was found with preset: ', preset);
            }
            return null;
        },
        changeMode: function changeMode(mode) {
            this.currentMode = mode;
        },
        changeBackButtonBehavior: function changeBackButtonBehavior(val) {
            this.currentBackButtonBehavior = val;
        },
        changeSwitcherLayout: function changeSwitcherLayout(val) {
            this.currentSwitcherLayout = val;
        },
        changeShowAllBehavior: function changeShowAllBehavior(val) {
            this.currentShowAllBehavior = val;
        },
        changeAltClickMode: function changeAltClickMode(val) {
            this.currentAltClickMode = val;
        },
        addToast: function addToast() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.toasts = [data];
        },
        togglePane: function togglePane(key, state) {
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.currentApp.panes, key, typeof state === 'boolean' ? state : typeof this.currentApp.panes[key] === 'undefined' ? false : !this.currentApp.panes[key]);
        },
        replaceAppState: function replaceAppState(newAppState) {
            this.currentApp.appState = newAppState;
        },
        switchContext: function switchContext(data) {
            var appStateHistory = this.currentApp.appStateHistory;

            this.transitionId = this.randomId();

            // Current app (before switch)
            var currentApp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.currentApp);

            // On switch context we don't have an old stack id
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.currentApp, 'oldStackId', null);

            // Update the current stack ID
            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.currentApp, 'stackId', data.stackId);

            // We need to save the current app state stack in history (not the clicked/requested one)
            // before replacing with the one the user clicked on
            // Note: It should always be found in the history
            // so it's only a formality that we check for it
            var currentAppHistoryIndex = appStateHistory.findIndex(function (i) {
                return i.stackId === currentApp.stackId;
            });
            if (currentAppHistoryIndex >= 0) {
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.currentApp.appStateHistory, currentAppHistoryIndex, {
                    // ...this.currentApp.appStateHistory[currentAppHistoryIndex],
                    stackId: currentApp.stackId,
                    stack: currentApp.appState
                });
            } else {
                console.error('Whoops! The stack ID of ' + currentApp.stackId + ' was not found in current app state history (which it should!)');
            }

            // Now we replace the app state with the selected stack
            // And set the stackId
            this.replaceAppState(data.stack);

            this.showAppSwitcher = false;
        },


        // Adds initial app state to history
        // so that the app switcher has at least one item
        addInitialAppStateToHistory: function addInitialAppStateToHistory() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.routes).forEach(function (key) {
                var randomId = _this2.randomId();
                var route = _this2.routes[key];
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(route, 'stackId', randomId);
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(route, 'appStateHistory', [{
                    stack: route.appState,
                    stackId: randomId
                }]);
            });
        },
        toggleContextSwitcher: function toggleContextSwitcher(state) {
            this.showAppSwitcher = typeof state === 'boolean' ? state : !this.showAppSwitcher;
        },
        closePreviewPane: function closePreviewPane() {
            this.updateCurrentViewData({
                pane: false
            });
            this.togglePane('preview', false);
        },


        // Change route (app)
        changeRoute: function changeRoute(key) {
            var toast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.toggleContextSwitcher(false);
            this.currentApp.dropdown = false;
            this.currentRouteKey = key;
            var app = this.routes[key];

            if (toast && app) {
                this.addToast({
                    title: app.name,
                    icon: app.key
                });
            }
        },


        // Push to app state
        pushToAppState: function pushToAppState(Data) {
            var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var stateId = this.randomId();
            var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Data, { stateId: stateId });
            var appState = this.currentApp.appState;
            var appStateLength = appState.length;
            // If root is set to true we replace the app state
            // just before the first item (which is home)
            if (root) {
                this.currentApp.appState = [appState[0]];
                this.currentApp.appState.push(data);
            } else {
                this.currentApp.appState.push(data);
            }
        },


        // Check if context switch is allowed
        shouldUpdateContext: function shouldUpdateContext(currentView, nextView) {
            // Don't do context switch within the users app
            if (nextView.owner === 'users' && currentView.owner === nextView.owner) {
                return false;
            }

            return true;
        },


        // Change view (inside app)
        changeView: function changeView(data, callback) {
            var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var currentAltClickMode = this.currentAltClickMode,
                shouldUpdateContext = this.shouldUpdateContext;

            var currentMode = this.currentMode;
            this.closeDropdown();

            /**
             * In some circumstances we don't want to allow context switch
             * e.g. the users app (when viewing fees, loans etc.)
             */

            var contextSwitchAllowed = shouldUpdateContext(this.currentView, data);

            /**
             * If alt-key is pressed
             * we change the behavior here
             */

            if (__WEBPACK_IMPORTED_MODULE_11_keymaster___default.a.isPressed(18) && currentAltClickMode) {
                currentMode = currentAltClickMode;
            }

            /**
             * Modes
             */

            switch (currentMode) {
                // Mode A
                case 'OWNER_APP_CLEAR':
                    if (contextSwitchAllowed) {
                        this.changeRoute(data.owner, true);
                        this.clearAppState();
                    }

                    this.pushToAppState(data, root);
                    break;

                // Mode B
                case 'SAME_APP_ADD':
                    this.pushToAppState(data, root);
                    break;

                // Mode C
                case 'OWNER_APP_NEW_CONTEXT':
                    if (contextSwitchAllowed) {
                        // Change route
                        this.changeRoute(data.owner, true);

                        // Save current context and clear
                        this.addNewContextToCurrentApp([data]);
                    } else {
                        this.pushToAppState(data, root);
                    }

                    break;

                // case 'OWNER_APP_ADD':
                //     this.changeRoute(data.owner, true);
                //     this.pushToAppState(data, root);
                // break;

                // case 'MODIFIER_1':
                //     if (keymaster.isPressed(18)) {
                //         this.changeRoute(data.owner, true);
                //         this.addNewContextToCurrentApp([data]);
                //     } else {
                //         this.pushToAppState(data, root);
                //     }
                // break;
                //
                // case 'MODIFIER_2':
                // if (keymaster.isPressed(18)) {
                //     this.changeRoute(data.owner, true);
                //     this.clearAppState();
                //     this.pushToAppState(data, root);
                // } else {
                //     this.pushToAppState(data, root);
                // }
                // break;
            }

            /**
             * Callback
             */

            if (typeof callback === 'function') {
                callback();
            }
        },


        // Clear app state (except the first item)
        clearAppState: function clearAppState() {
            var currentApp = this.currentApp;

            var currentAppState = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(currentApp.appState));
            currentApp.appState = [currentAppState[0]];
        },


        // New context
        addNewContextToCurrentApp: function addNewContextToCurrentApp(newAppState) {
            var currentApp = this.currentApp;

            // [HACK ALERT] The change of the transitionId triggers the animation
            // so we can control when to show context switcher animations

            this.transitionId = this.randomId();

            // Clone current app state
            var currentAppState = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(currentApp.appState));

            // Generate new stack ID
            var randomId = this.randomId();

            // Save current app state in app history
            var currentAppHistoryIndex = currentApp.appStateHistory.findIndex(function (i) {
                return i.stackId === currentApp.stackId;
            });
            if (currentAppHistoryIndex >= 0) {
                __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(currentApp.appStateHistory, currentAppHistoryIndex, {
                    stackId: currentApp.stackId,
                    stack: currentAppState
                });
            }

            __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].set(this.currentApp, 'oldStackId', currentApp.stackId);

            // Add new context to history
            this.currentApp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.currentApp, {
                stackId: randomId,
                appStateHistory: [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(currentApp.appStateHistory), [{
                    stackId: randomId,
                    stack: newAppState
                }])
            });

            // Make fresh context
            this.currentApp.appState = newAppState;
        },


        // addContextToAppHistory(appState, stackId) {
        //     this.currentApp.appStateHistory.concat([{
        //         stackId,
        //         stack: appState,
        //     }]);
        // },

        // Generate random ID
        randomId: function randomId() {
            return '' + chance.natural() + chance.syllable();
        },


        // Update breadcrumbs
        updateBreadcrumbs: function updateBreadcrumbs(i) {
            var appState = this.currentApp.appState;

            var view = appState[i];
            if (appState.length > 1) {
                // Slice breadcrumbs
                var newappState = appState.filter(function (app, index) {
                    return index <= i;
                });

                this.closeDropdown();
                this.currentApp.appState = newappState;
            }
        },


        // Update current view
        updateCurrentViewData: function updateCurrentViewData(data) {
            this.currentView.data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.currentView.data, data);
        },


        // Replace current view
        replaceCurrentViewData: function replaceCurrentViewData(data) {
            this.currentView.data = data;
        },


        // Go back (one step back in current breadcrumb)
        goBack: function goBack() {
            if (this.currentApp.appState.length >= 2) {
                this.currentApp.appState.splice(-1, 1);
            }
        },


        // Console log current app state (useful if we want to make the example with multiple state pr. app)
        consoleLogCurrentAppState: function consoleLogCurrentAppState() {
            var currentApp = this.currentApp;

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentApp.appState));
        },


        // Toggle breadcrumb dropdown
        toggleDropdown: function toggleDropdown() {
            this.currentApp.dropdown = !this.currentApp.dropdown;
        },


        // Close breadcrumb dropdown
        closeDropdown: function closeDropdown() {
            if (this.currentApp) {
                this.currentApp.dropdown = false;
            }
        }
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymaster__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keymaster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppSwitcherPreview__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppSwitcherPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AppSwitcherPreview__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_keymaster___default.a.setScope('app-switcher');
        __WEBPACK_IMPORTED_MODULE_0_keymaster___default.a.filter = function () {
            return true;
        };
        __WEBPACK_IMPORTED_MODULE_0_keymaster___default()('esc', function () {
            _this.tools.actions.toggleContextSwitcher(false);
        });
    },
    data: function data() {
        return {
            activeClasses: 'big',
            justCreatedClasses: '',
            currentStackId: null,
            visible: false,
            savedTransitionId: null
        };
    },

    watch: {
        currentApp: function currentApp(val) {
            var _this2 = this;

            var stackIdUpdated = val.stackId !== this.currentStackId;
            var appStateHistory = this.currentApp.appStateHistory;

            if (this.tools.transitionId !== this.savedTransitionId && this.currentApp.oldStackId) {

                // Fade in new element
                setTimeout(function () {
                    var newlyAddedElement = document.getElementById(_this2.currentApp.stackId);
                    console.log('newly added element', newlyAddedElement);
                    newlyAddedElement.classList.add('is-hidden');
                }, 25);

                this.savedTransitionId = this.tools.transitionId;
                this.currentStackId = this.currentApp.oldStackId;
                // Make currently active big
                this.activeClasses = 'big';
                this.visible = true;
                // Remove big
                setTimeout(function () {
                    _this2.activeClasses = '';
                }, 275);
                setTimeout(function () {
                    _this2.currentStackId = _this2.currentApp.stackId;
                }, 800);
                // Set new stack ID
                setTimeout(function () {
                    _this2.activeClasses = 'big';
                }, 1100);
                // Hide switcher
                setTimeout(function () {
                    _this2.visible = false;
                }, 1350);
            }
        },
        appHistory: function appHistory(appStateHistory) {
            if (appStateHistory.length === 1) {
                this.currentStackId = this.currentApp.stackId;
            }
        },
        show: function show(val) {
            var _this3 = this;

            // this.currentStackId = this.currentApp.stackId;
            this.activeClasses = 'big';
            if (val === true) {
                setTimeout(function () {
                    _this3.activeClasses = '';
                }, 300);
                this.visible = val;
            } else {
                this.activeClasses = 'big';
                setTimeout(function () {
                    _this3.visible = false;
                }, 300);
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0_keymaster___default.a.deleteScope('app-switcher');
    },

    name: 'app-context-switcher',
    props: ['tools', 'show', 'appHistory'],
    components: {
        'app-context-switcher-preview': __WEBPACK_IMPORTED_MODULE_1__AppSwitcherPreview___default.a
    },
    computed: {
        currentApp: function currentApp() {
            return this.tools.currentApp;
        }
    },
    methods: {
        switchContext: function switchContext(preview) {
            var _this4 = this;

            this.currentStackId = preview.stackId;
            this.activeClasses = 'big';
            setTimeout(function () {
                _this4.tools.actions.switchContext(preview);
                _this4.visible = false;
            }, 200);
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-context-switcher-preview',
    props: ['tools', 'preview', 'active'],
    computed: {
        // The visible item is the last in the stack
        visibleStackItem: function visibleStackItem() {
            var preview = this.preview,
                tools = this.tools;
            // If preview is the current; show content from current

            if (preview.stackId === tools.currentApp.stackId) {
                return this.tools.currentApp.appState[this.tools.currentApp.appState.length - 1];
            }
            return this.preview.stack[this.preview.stack.length - 1];
        },
        title: function title() {
            var value = this.visibleStackItem.title;
            var n = 34;
            return value && value.length > n ? value.substr(0, n - 1) + '...' : value;
        }
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Ps from 'perfect-scrollbar';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-breadcrumbs',
    props: ['data', 'updateBreadcrumbs', 'currentApp', 'toggleDropdown', 'dropdownVisible', 'tools', 'showAppSwitcher', 'showBreadcrumbs'],
    methods: {
        concat: function concat(value) {
            var n = 25;
            return value && value.length > n ? value.substr(0, n - 1) + '...' : value;
        }
    },
    computed: {
        showContextSwitcherButton: function showContextSwitcherButton() {
            return this.tools.modifiers.currentMode === 'OWNER_APP_NEW_CONTEXT' || this.tools.modifiers.currentMode === 'MODIFIER_1';
        }
    }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymaster__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keymaster__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mode-switcher',
    mounted: function mounted() {
        var _this = this;

        // Get persisted preset
        var preset = this.getPersistedValue('APP_PRESET');
        if (preset) {
            this.currentPreset = preset;
        } else {
            this.currentPreset = 1;
            this.savePreset(1);
        }

        // Add shortcut for debugger
        var key = __WEBPACK_IMPORTED_MODULE_0_keymaster___default.a;
        key.filter = function () {
            return true;
        };
        key('m', function () {
            _this.visible = !_this.visible;
        });
        key('esc', function () {
            if (_this.visible === true) {
                _this.visible = false;
            }
        });
    },
    data: function data() {
        return {
            visible: false,
            advanced: false,
            currentPreset: 1,
            presets: [{
                label: 'Preset 1',
                value: 1
            }, {
                label: 'Preset 2',
                value: 2
            }, {
                label: 'Preset 3',
                value: 3
            }, {
                label: 'Preset 4',
                value: 4
            }]
        };
    },

    watch: {
        currentPreset: function currentPreset(preset) {
            this.savePreset(preset);
        }
    },
    methods: {
        savePreset: function savePreset(preset) {
            this.setPreset(parseInt(preset, 10));
            this.persistValue('APP_PRESET', preset);
        },
        toggle: function toggle() {
            this.visible = !this.visible;
        },
        persistValue: function persistValue(key, value) {
            if (typeof localStorage !== 'undefined' && value) {
                localStorage.setItem(key, value);
            }
        },
        getPersistedValue: function getPersistedValue(key) {
            if (typeof localStorage === 'undefined') {
                return false;
            }

            return localStorage.getItem(key);
        },
        setPreset: function setPreset(number) {
            var onChangeMode = this.onChangeMode,
                onChangeSwitcherLayout = this.onChangeSwitcherLayout,
                onChangeBackButtonBehavior = this.onChangeBackButtonBehavior,
                onChangeShowAllBehavior = this.onChangeShowAllBehavior;
            // Preset 1 (mode: A, boxes, back, home with search)
            // Preset 2 (mode: B, boxes, back, full list)
            // Preset 3 (mode: C, boxes, back, home with search)
            // Preset 4 (mode: C, tabs, back button, home with search)

            switch (number) {
                case 1:
                    onChangeMode('OWNER_APP_CLEAR');
                    onChangeSwitcherLayout('boxes');
                    onChangeBackButtonBehavior('dont_show');
                    onChangeShowAllBehavior('owner_home');
                    break;
                case 2:
                    onChangeMode('SAME_APP_ADD');
                    onChangeSwitcherLayout('boxes');
                    onChangeBackButtonBehavior('show_back');
                    onChangeShowAllBehavior('full_list');
                    break;
                case 3:
                    onChangeMode('OWNER_APP_NEW_CONTEXT');
                    onChangeSwitcherLayout('boxes');
                    onChangeBackButtonBehavior('dont_show');
                    onChangeShowAllBehavior('owner_home');
                    break;
                case 4:
                    onChangeMode('OWNER_APP_NEW_CONTEXT');
                    onChangeSwitcherLayout('tabs');
                    onChangeBackButtonBehavior('show_back');
                    onChangeShowAllBehavior('owner_home');
                    break;
            }
        }
    },
    props: ['currentMode', 'availableModes', 'onChangeMode', 'backButtonBehaviors', 'currentBackButtonBehavior', 'onChangeBackButtonBehavior', 'switcherLayouts', 'currentSwitcherLayout', 'onChangeSwitcherLayout', 'currentShowAllBehavior', 'showAllBehaviors', 'onChangeShowAllBehavior', 'currentAltClickMode', 'altClickModes', 'onChangeAltClickMode']
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_BasicView__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_BasicView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_BasicView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_PaneView__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_PaneView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_PaneView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_OrdersView__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_OrdersView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_OrdersView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_PackagesView__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_PackagesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_PackagesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_InstancesView__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_InstancesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_InstancesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ItemsView__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ItemsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_ItemsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_UsersView__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_UsersView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_UsersView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ShowAllView__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ShowAllView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_ShowAllView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_PaneFullView__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_PaneFullView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_PaneFullView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_LoansView__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_LoansView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_LoansView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_LoanDetailsView__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_LoanDetailsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_LoanDetailsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_FeesView__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_FeesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_FeesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_FeeDetailsView__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_FeeDetailsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_FeeDetailsView__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'view-container',
    props: ['tools'],
    components: {
        BasicView: __WEBPACK_IMPORTED_MODULE_0__views_BasicView___default.a, PaneView: __WEBPACK_IMPORTED_MODULE_1__views_PaneView___default.a, OrdersView: __WEBPACK_IMPORTED_MODULE_2__views_OrdersView___default.a, PackagesView: __WEBPACK_IMPORTED_MODULE_3__views_PackagesView___default.a, InstancesView: __WEBPACK_IMPORTED_MODULE_4__views_InstancesView___default.a, ItemsView: __WEBPACK_IMPORTED_MODULE_5__views_ItemsView___default.a, ShowAllView: __WEBPACK_IMPORTED_MODULE_7__views_ShowAllView___default.a, PaneFullView: __WEBPACK_IMPORTED_MODULE_8__views_PaneFullView___default.a, UsersView: __WEBPACK_IMPORTED_MODULE_6__views_UsersView___default.a, LoansView: __WEBPACK_IMPORTED_MODULE_9__views_LoansView___default.a, LoanDetailsView: __WEBPACK_IMPORTED_MODULE_10__views_LoanDetailsView___default.a, FeesView: __WEBPACK_IMPORTED_MODULE_11__views_FeesView___default.a, FeeDetailsView: __WEBPACK_IMPORTED_MODULE_12__views_FeeDetailsView___default.a
    },
    methods: {
        showView: function showView(key) {
            return this.tools.currentView.key === key;
        }
    }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-tabs',
    props: ['appHistory', 'tools'],
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar___default.a.initialize(document.getElementById('tabs'));
    },

    watch: {
        currentRoute: function currentRoute() {
            __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar___default.a.update(document.getElementById('tabs'));
        }
    },
    computed: {
        routes: function routes() {
            var routes = this.tools.routes;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(routes).map(function (key) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(routes[key], { routeKey: key });
            });
        },
        currentRoute: function currentRoute() {
            return this.tools.currentRouteKey;
        },
        tabs: function tabs() {
            return this.appHistory;
        },
        currentStackId: function currentStackId() {
            return this.tools.currentApp.stackId;
        },
        canDeleteTabs: function canDeleteTabs() {
            return this.tabs.length > 1;
        }
    },
    methods: {
        closeTab: function closeTab(tab) {
            var tabs = this.tabs;
            var index = tabs.findIndex(function (t) {
                return t.stackId === tab.stackId;
            });

            // Go to prev tab
            var nextTab = typeof tabs[index + 1] !== 'undefined' ? tabs[index + 1] : tabs[index - 1];
            this.onSwitch(nextTab);

            // Delete tab
            __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].delete(tabs, index);
        },
        onSwitch: function onSwitch(tab) {
            if (!this.isActive(tab) && this.tabs.findIndex(function (t) {
                return t.stackId === tab.stackId;
            }) >= 0) {
                this.tools.actions.switchContext(tab);
            }
        },
        isActive: function isActive(tab) {
            return tab.stackId === this.currentStackId;
        },
        visibleStackItem: function visibleStackItem(tab) {
            var tools = this.tools;
            // If preview is the current; show content from current

            if (tab.stackId === tools.currentApp.stackId) {
                return this.tools.currentApp.appState[this.tools.currentApp.appState.length - 1];
            }
            return tab.stack[tab.stack.length - 1];
        },
        resizeTabs: function resizeTabs() {
            var tabs = this.tabs;
            var container = document.getElementById('tabs');
            var containerInner = container.querySelector('.app-tabs__inner');
            var containerWidth = container.clientWidth;
            setTimeout(function () {
                // if (tabs.length && containerInner.clientWidth > container.clientWidth) {
                if (tabs.length) {
                    var commonWidth = Math.floor(container.clientWidth / tabs.length);
                    console.log('container', container.clientWidth);
                    tabs.forEach(function (tab) {
                        var el = document.getElementById(tab.stackId);
                        var innerWidth = el.querySelector('.app-tabs__item__inner').clientWidth;
                        if (innerWidth > commonWidth) {
                            el.style.width = commonWidth + 'px';
                        } else {
                            el.style.width = innerWidth + 'px';
                        }
                        // console.log(innerWidth);
                        // console.dir(el);
                    });
                }
            }, 50);
        }
    }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-toasts',
    props: ['toasts', 'tools'],
    data: function data() {
        return {
            toast: false
        };
    },

    watch: {
        toasts: function toasts(_toasts) {
            var _this = this;

            if (this.interval) {
                clearInterval(this.interval);
            }

            this.toast = false;
            this.toast = _toasts[0];
            this.interval = setInterval(function () {
                _this.toast = false;
            }, 1200);
        }
    }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-instance-template',
    props: ['tools', 'hideHeader'],
    computed: {
        instance: function instance() {
            return this.tools.currentView.data.pane;
        }
    }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-item-template',
    props: ['tools', 'hideHeader'],
    computed: {
        item: function item() {
            return this.tools.currentView.data.pane;
        }
    }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-order-template',
    props: ['tools', 'hideHeader'],
    computed: {
        order: function order() {
            return this.tools.currentView.data.pane;
        }
    }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-package-template',
    props: ['tools', 'hideHeader'],
    computed: {
        package: function _package() {
            return this.tools.currentView.data.pane;
        }
    }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-user-template',
    props: ['tools', 'hideHeader'],
    data: function data() {
        return {
            expandAll: null
        };
    },

    computed: {
        user: function user() {
            return this.currentView.data.pane;
        },
        currentView: function currentView() {
            return this.tools.currentView;
        }
    },
    methods: {
        toggleExpandAll: function toggleExpandAll() {
            this.expandAll = typeof this.expandAll !== 'boolean' ? false : !this.expandAll;
        },
        isCollapsed: function isCollapsed(defaultState) {
            if (typeof this.expandAll === 'boolean') {
                return this.expandAll;
            }

            return typeof defaultState !== 'undefined' ? defaultState : true;
        },
        changeViewRelativeToUser: function changeViewRelativeToUser(data) {
            var user = this.user,
                currentView = this.currentView;


            this.tools.changeView(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, currentView, {
                key: 'users-view',
                title: user.name
            }), null, true);

            this.tools.changeView(data);
        },
        viewUserLoans: function viewUserLoans() {
            var user = this.user;


            this.changeViewRelativeToUser({
                key: 'loans-view',
                title: 'Loan History',
                owner: 'users',
                data: {
                    user: user
                }
            });
        },
        viewUserFees: function viewUserFees() {
            var user = this.user;


            this.changeViewRelativeToUser({
                key: 'fees-view',
                title: 'Fee/fine history',
                owner: 'users',
                data: {
                    user: user
                }
            });
        }
    }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-icon',
    props: {
        tools: true,
        size: {
            default: 'default'
        },
        name: {
            type: String
        }
    },
    computed: {
        getName: function getName() {
            return this.name;
        },
        icon: function icon() {
            if (this.tools) {
                var key = this.getName;
                var appIcons = this.tools.appIcons;

                if (appIcons[key]) {
                    return appIcons[key];
                }
            }

            return false;
        }
    }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-icon-button',
    props: ['prototype']
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'inventory-block',
    props: ['order']
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'order-details',
    props: ['order']
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-content-with-sidebar',
    props: ['updateWhenThisValueChanges'],
    mounted: function mounted() {
        this.container = this.$el;
        this.container.addEventListener('scroll', this.onScroll);
        this.tabs = this.slotsToTabs;
        this.setAsActive(0);
    },
    data: function data() {
        return {
            tabs: [],
            tabPositions: [],
            active: null,
            scrollDetection: true
        };
    },

    watch: {
        tabs: function tabs() {
            this.updatePositions();
        },
        updateWhenThisValueChanges: function updateWhenThisValueChanges() {
            this.updatePositions();
        },
        scrollDetection: function scrollDetection() {
            var _this = this;

            setTimeout(function () {
                _this.updatePositions();
                _this.scrollDetection = true;
            }, 500);
        }
    },
    computed: {
        slotsToTabs: function slotsToTabs() {
            var _this2 = this;

            return this.$slots.default.filter(function (s) {
                return typeof s.tag !== 'undefined';
            }).map(function (t, i) {
                var propsData = t.componentOptions.propsData;
                var title = t.componentOptions.propsData.title;
                return {
                    onClick: function onClick() {
                        _this2.scrollDetection = false;
                        _this2.setAsActive(i);
                    },
                    title: title,
                    href: '#' + _this2.slugify(title.toLowerCase()),
                    el: t.elm,
                    propsData: propsData
                };
            });
        }
    },
    methods: {
        slugify: function slugify(text) {
            return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w\-]+/g, '') // Remove all non-word chars
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, ''); // Trim - from end of text
        },
        updatePositions: function updatePositions() {
            var _this3 = this;

            setTimeout(function () {
                _this3.tabPositions = _this3.tabs.map(function (tab, index) {
                    return {
                        offsetTop: tab.el.offsetTop
                    };
                });
            }, 50);
        },


        onScroll: function onScroll() {
            var tabs = this.tabs;
            var scrollTop = this.container.scrollTop + 49;
            var tabPositions = this.tabPositions;
            if (this.scrollDetection) {
                for (var i = 0; i < tabPositions.length; i++) {
                    var tabPosition = tabPositions[i];
                    if (tabPosition.offsetTop <= scrollTop) {
                        this.setAsActive(i, false);
                    }
                }
            }
        },
        setAsActive: function setAsActive(index) {
            var scrollIntoView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.handleActiveState(this.tabs[index], scrollIntoView);
            this.active = index;
        },
        handleActiveState: function handleActiveState(tab, scrollIntoView) {
            var el = tab.el;

            el.classList.remove('collapsed');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(tab.propsData, 'isCollapsed', false);

            // if (scrollIntoView) {
            //     el.scrollIntoView({
            //         behavior: 'smooth',
            //         block: 'nearest',
            //     });
            // }
        }
    }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-header',
    props: ['title', 'subtitle', 'hasSearchIcon', 'tools', 'hasBackButton', 'appIconKey', 'hasCloseIcon', 'hasCloseSearchIcon'],
    data: function data() {
        return {
            showSearchPane: true
        };
    },

    computed: {
        showCloseButton: function showCloseButton() {
            return this.hasBackButton === true && this.tools.modifiers.hideBackButton !== false && this.tools.modifiers.currentBackButtonBehavior === 'show_close';
        },
        showBackButton: function showBackButton() {
            return this.hasBackButton === true && this.tools.modifiers.hideBackButton !== false && this.tools.modifiers.currentBackButtonBehavior === 'show_back';
        }
    }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-header-search'
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pane_templates_OrderPaneTemplate__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pane_templates_OrderPaneTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pane_templates_OrderPaneTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pane_templates_InstancePaneTemplate__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pane_templates_InstancePaneTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pane_templates_InstancePaneTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pane_templates_ItemPaneTemplate__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pane_templates_ItemPaneTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pane_templates_ItemPaneTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pane_templates_PackagePaneTemplate__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pane_templates_PackagePaneTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pane_templates_PackagePaneTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pane_templates_UserPaneTemplate__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pane_templates_UserPaneTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pane_templates_UserPaneTemplate__);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-preview-container',
    components: {
        'pane-order-template': __WEBPACK_IMPORTED_MODULE_0__pane_templates_OrderPaneTemplate___default.a,
        'pane-instance-template': __WEBPACK_IMPORTED_MODULE_1__pane_templates_InstancePaneTemplate___default.a,
        'pane-item-template': __WEBPACK_IMPORTED_MODULE_2__pane_templates_ItemPaneTemplate___default.a,
        'pane-package-template': __WEBPACK_IMPORTED_MODULE_3__pane_templates_PackagePaneTemplate___default.a,
        'pane-user-template': __WEBPACK_IMPORTED_MODULE_4__pane_templates_UserPaneTemplate___default.a
    },
    props: ['tools', 'hideHeader'],
    computed: {
        content: function content() {
            return this.tools.currentView.data.pane.data;
        },
        hasPane: function hasPane() {
            return !!(this.tools.currentView.data && this.tools.currentView.data.pane);
        }
    }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-section',
    props: ['tools', 'title', 'preset', 'tableHeader', 'itemCount', 'itemCountMax', 'itemCountMin', 'hasButton', 'isCollapsed', 'includeInList'],
    data: function data() {
        return {
            showSearchPane: true,
            collapsed: false
        };
    },
    mounted: function mounted() {
        if (typeof this.isCollapsed === 'boolean') {
            this.collapsed = this.isCollapsed;
        }
    },

    watch: {
        isCollapsed: function isCollapsed(val) {
            if (typeof val === 'boolean') {
                this.collapsed = val;
            }
        }
    },
    computed: {
        content: function content() {
            return this.tools.currentView.data.pane;
        },
        hasSlot: function hasSlot() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$slots).length;
        }
    },
    methods: {
        onViewAll: function onViewAll() {
            var tools = this.tools;

            // Show full list when clicking "Show all"

            if (tools.modifiers.currentShowAllBehavior === 'full_list') {
                tools.changeView({
                    key: 'show-all-view',
                    title: this.title,
                    owner: tools.helpers.presetToKey(this.preset),
                    data: {
                        headerTitle: '' + this.title,
                        headerSub: this.content.title,
                        preset: this.preset
                    }
                });
            } else if (tools.modifiers.currentShowAllBehavior === 'owner_home') {
                var key = tools.helpers.presetToKey(this.preset);
                var randomContent = tools.generator.randomContentOfType(this.preset);
                var searchText = tools.currentPaneKey + '-id:' + (randomContent.id ? randomContent.id : tools.randomizer.bb_pin());
                tools.changeView({
                    title: searchText,
                    key: key + '-view',
                    owner: key,
                    data: {
                        search: {
                            show: true,
                            value: searchText
                        },
                        pane: randomContent
                    }
                },
                // Callback
                function () {
                    tools.actions.togglePane('preview', false);
                    tools.actions.togglePane('search', true);
                });
            }
        }
    }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'skeleton-lines',
    props: ['lines']
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-button',
    props: ['title', 'iconLeft', 'iconRight']
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-checklist',
    props: ['title', 'items']
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_generator__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dummy_data_list__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chance__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chance__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var chance = new __WEBPACK_IMPORTED_MODULE_3_chance___default.a();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-data-list',
    props: ['items', 'header', 'itemCount', 'tools', 'preset', 'row', 'selected', 'type', 'cache', 'maxItems', 'minItems', 'sortBy', 'hasCheckBox', 'includeInList', 'dropdown'],
    mounted: function mounted() {
        this.cachedList = this.list;
    },
    data: function data() {
        return {
            cachedList: [],
            hasSelected: false
        };
    },

    computed: {
        getItemCount: function getItemCount() {
            var minItems = this.minItems,
                maxItems = this.maxItems,
                itemCount = this.itemCount;


            if (minItems && maxItems) {
                return chance.natural({ min: minItems, max: maxItems });
            }

            if (itemCount) {
                return itemCount;
            }

            // Default
            return 5;
        },
        cached: function cached() {
            var renderList = this.cachedList;
            if (this.cache === false) {
                renderList = this.list;
            }

            return renderList.sort(function (a, b) {
                if (typeof a.sortBy !== 'undefined') {
                    if (a.sortBy < b.sortBy) {
                        return -1;
                    }
                    if (a.sortBy > b.sortBy) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                }
                return a;
            });
        },
        currentPaneContent: function currentPaneContent() {
            return this.tools.currentView.data.pane;
        },
        tableOptions: function tableOptions() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dummy_data_list__["a" /* default */])(this.tools);
        },
        list: function list() {
            if (this.preset) {
                return __WEBPACK_IMPORTED_MODULE_1__helpers_generator__["a" /* default */].randomList(this.preset, this.getItemCount, this.includeInList).map(this.tableRow);
            }

            if (this.items) {
                return this.items;
            }

            return [];
        },
        tableHeader: function tableHeader() {
            var tableOptions = this.tableOptions,
                preset = this.preset,
                type = this.type,
                header = this.header;


            if (header) {
                return header;
            }

            if (typeof preset === 'string' && typeof type === 'string' && typeof tableOptions[preset] !== 'undefined' && typeof tableOptions[preset][type] !== 'undefined') {
                return tableOptions[preset][type].header;
            }

            return [];
        }
    },
    methods: {
        tableRow: function tableRow(data) {
            var tableOptions = this.tableOptions,
                preset = this.preset,
                type = this.type,
                header = this.header,
                row = this.row;


            if (typeof row === 'function') {
                return row(data);
            }

            if (typeof preset === 'string' && typeof type === 'string' && typeof tableOptions[preset] !== 'undefined' && typeof tableOptions[preset][type] !== 'undefined') {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tableOptions[preset][type].row(data), {
                    data: data
                });
            }

            return [];
        },
        onClick: function onClick(row) {
            if (typeof row.onClick === 'function') {
                row.onClick();
            }
        },
        selectedClass: function selectedClass(row, i) {
            if (row.data && this.currentPaneContent && row.data.id === this.currentPaneContent.id) {
                this.hasSelected = true;
                return 'selected';
            } else if (this.selected === i && !this.hasSelected) {
                return 'selected';
            }

            return null;
        }
    }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-details',
    props: ['title', 'cover', 'list', 'image', 'size'],
    computed: {
        coverStyle: function coverStyle() {
            if (this.image) {
                return {
                    'background-image': 'url(' + this.image + ')'
                };
            }

            return false;
        }
    }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-dropdown',
    props: ['list'],
    data: function data() {
        return {
            open: false
        };
    },

    methods: {
        onClick: function onClick() {
            this.open = false;
        }
    }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-headline',
    props: ['text']
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-icon',
    props: ['name']
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-link',
    props: ['onClick']
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-padding'
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-scrollable-container',
    mounted: function mounted() {
        this.container = this.$el;
        if (!this.disabled) {
            __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar___default.a.initialize(this.container);
            __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar___default.a.update(this.container);
        }
    },

    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        refresh: function refresh() {
            __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar___default.a.update(this.container);
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (!this.disabled) {
            __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar___default.a.destroy(this.container);
        }
    }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-search-field',
    props: ['title', 'tools'],
    computed: {
        inputValue: function inputValue() {
            var tools = this.tools;

            var currentView = tools.currentView;
            var data = currentView.data;
            if (tools && data.search && data.search.value) {
                return data.search.value;
            }
            return '';
        }
    }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ui-tab-list',
    props: ['tabs', 'active', 'callback'],
    methods: {
        handleClick: function handleClick(tab) {
            if (typeof tab.onClick === 'function') {
                tab.onClick(tab);
            }
            if (typeof this.callback === 'function') {
                console.log('has callback');
                this.callback();
            }
        }
    }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        console.log('Basic view mounted', this);
        console.log('randomizer', this.tools.randomizer);
        console.log('tools', this.tools);
    },

    name: 'view-basic',
    props: ['tools', 'viewKey']
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        console.log('Loans view loaded', this);
        console.log('Current view', this.currentView);
        console.log('Current app', this.currentApp);
    },

    computed: {
        currentView: function currentView() {
            return this.tools.currentView;
        },
        currentApp: function currentApp() {
            return this.tools.currentApp;
        },
        fee: function fee() {
            return this.currentView.data;
        },
        user: function user() {
            return this.currentView.data.includes.user;
        }
    },
    name: 'fee-details-view',
    props: ['tools', 'viewKey'],
    methods: {
        viewLoanDetails: function viewLoanDetails() {
            var user = this.user,
                currentView = this.currentView;

            // Go to root (user)

            this.tools.changeView({
                key: 'users-view',
                owner: 'users',
                title: user.name,
                data: {
                    user: user,
                    pane: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user)
                }
            }, null, true);

            // Add loans history to breadcrumb
            this.tools.changeView({
                key: 'loans-view',
                title: 'Loans History',
                owner: 'users',
                data: {
                    user: user,
                    includes: { user: user }
                }
            });

            // Add fee details to breadcrumb
            var loanData = this.tools.generator.randomContentOfType('loan');
            this.tools.changeView({
                key: 'loan-details-view',
                title: loanData.breadcrumb,
                owner: 'users',
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, loanData, {
                    user: user,
                    includes: { user: user }
                })
            });
        }
    }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        currentView: function currentView() {
            return this.tools.currentView;
        },
        currentApp: function currentApp() {
            return this.tools.currentApp;
        },
        user: function user() {
            return this.currentView.data.user || this.currentView.data.includes.user;
        },
        fee: function fee() {
            return this.currentView.data;
        }
    },
    name: 'fees-view',
    props: ['tools', 'viewKey'],
    methods: {
        showLoanDetails: function showLoanDetails(localData) {
            var data = this.tools.generator.randomContentOfType('loan');
            var user = this.user;
            var fee = this.fee;
            this.tools.changeView({
                key: 'loan-details-view',
                title: 'Loan ' + data.loan_id,
                owner: 'users',
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, localData, {
                    includes: { user: user }
                })
            });
        },
        showFeeDetails: function showFeeDetails(localData) {
            var data = this.tools.generator.randomContentOfType('fee');
            var user = this.user;
            this.tools.changeView({
                key: 'fee-details-view',
                title: data.breadcrumb,
                owner: 'users',
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
                    includes: { user: user }
                })
            });
        },
        dropdownOptions: function dropdownOptions(row) {
            var _this = this;

            var data = row.data;
            var user = this.user;

            return [{
                title: 'Fee/fine details',
                onClick: function onClick() {
                    return _this.showFeeDetails();
                }
            }, {
                title: 'Pay'
            }, {
                title: 'Waive'
            }, {
                title: 'Refund'
            }, {
                title: 'Transfer'
            }, {
                title: 'Error'
            }, {
                title: 'Loan details',
                onClick: function onClick() {
                    return _this.showLoanDetails(data);
                }
            }];
        }
    }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaneView__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'instances-view',
    props: ['tools'],
    components: {
        PaneView: __WEBPACK_IMPORTED_MODULE_0__PaneView___default.a
    }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaneView__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'items-view',
    props: ['tools'],
    components: {
        PaneView: __WEBPACK_IMPORTED_MODULE_0__PaneView___default.a
    }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        console.log('Loans view loaded', this);
        console.log('Current view', this.currentView);
        console.log('Current app', this.currentApp);
    },

    computed: {
        currentView: function currentView() {
            return this.tools.currentView;
        },
        currentApp: function currentApp() {
            return this.tools.currentApp;
        },
        loan: function loan() {
            return this.currentView.data;
        },
        user: function user() {
            return this.loan.includes.user;
        },
        details: function details() {
            var user = this.user,
                loan = this.loan,
                showFee = this.showFee;

            return [{
                label: 'Borrower',
                value: user.lastname + ', ' + user.firstname
            }, {
                label: 'Proxy Borrower',
                value: '-'
            }, 'break', {
                label: 'Title',
                value: loan.item_name
            }, {
                label: 'Authors',
                value: loan.authors
            }, {
                label: 'Barcode',
                value: loan.barcode
            }, {
                label: 'Call number',
                value: loan.call_number
            }, 'break', {
                label: 'Location',
                value: loan.location
            }, {
                label: 'Item status',
                value: loan.item_status
            }, {
                label: 'Due date',
                value: loan.due_date
            }, {
                label: 'Return date',
                value: loan.return_date
            }, {
                label: 'Renewal count',
                value: loan.renewal_count
            }, {
                label: 'Claim returned',
                value: loan.claim_returned
            }, 'break', {
                label: 'Loan policy',
                value: loan.loan_policy
            }, {
                label: 'Loan date',
                value: loan.loan_date
            }, {
                label: 'Fee/fine',
                value: loan.fee_fine,
                onClick: showFee
            }, {
                label: 'Request queue',
                value: loan.request_queue
            }, {
                label: 'lost',
                value: loan.lost
            }];
        }
    },
    name: 'loan-details-view',
    props: ['tools', 'viewKey'],
    methods: {
        showFee: function showFee() {
            var user = this.user,
                currentView = this.currentView;

            // Go to root (user)

            this.tools.changeView({
                key: 'users-view',
                title: user.name,
                owner: 'users',
                data: {
                    pane: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user)
                }
            }, null, true);

            // Add fees history to breadcrumb
            this.tools.changeView({
                key: 'fees-view',
                title: 'Fee/fine History',
                owner: 'users',
                data: {
                    includes: { user: user }
                }
            });

            // Add fee details to breadcrumb
            var feeData = this.tools.generator.randomContentOfType('fee');
            this.tools.changeView({
                key: 'fee-details-view',
                title: feeData.breadcrumb,
                owner: 'users',
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, feeData, {
                    user: user,
                    includes: { user: user }
                })
            });
        }
    }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    computed: {
        currentView: function currentView() {
            return this.tools.currentView;
        },
        currentApp: function currentApp() {
            return this.tools.currentApp;
        },
        user: function user() {
            return this.currentView.data.user;
        }
    },
    name: 'loans-view',
    props: ['tools', 'viewKey'],
    methods: {
        dropdownOptions: function dropdownOptions(row) {
            var _this = this;

            var data = row.data;
            var user = this.user;

            return [{
                title: 'Loan details',
                onClick: function onClick() {
                    _this.tools.changeView({
                        key: 'loan-details-view',
                        title: 'Loan ' + data.loan_id,
                        owner: 'users',
                        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
                            includes: { user: user }
                        })
                    });
                }
            }, {
                title: 'Claim returned'
            }, {
                title: 'Renew'
            }, {
                title: 'Change due date'
            }, {
                title: 'Change manual fee/fine'
            }, {
                title: 'Cancel loan'
            }];
        }
    }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaneView__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'order-view',
    props: ['tools'],
    components: {
        PaneView: __WEBPACK_IMPORTED_MODULE_0__PaneView___default.a
    }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaneView__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'packages-view',
    props: ['tools'],
    components: {
        PaneView: __WEBPACK_IMPORTED_MODULE_0__PaneView___default.a
    }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-full-view',
    props: ['tools']
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pane-view',
    props: ['tools', 'viewKey', 'currentApp', 'panes', 'previewPaneClass'],
    computed: {
        viewData: function viewData() {
            return this.tools.currentView.data;
        },
        hide: function hide() {
            return this.viewData.hide;
        },
        previewFullWidth: function previewFullWidth() {
            return !this.showPane('search') && !this.showPane('results');
        },
        showVignette: function showVignette() {
            return this.tools.currentApp.panes.search || this.tools.currentApp.panes.preview;
        }
    },
    watch: {
        // viewData(val) {
        //     // Toggle panes depending on view data
        //     if (val.showPanes) {
        //         val.showPanes.forEach((key) => {
        //             console.log('what', key);
        //             this.tools.actions.togglePane(key, true);
        //         });
        //     }
        // },
    },
    methods: {
        onVignetteClick: function onVignetteClick() {
            this.tools.actions.togglePane('search', false);
            this.tools.actions.closePreviewPane();
        },
        showPane: function showPane(key) {
            var hide = this.hide;

            if (hide && hide[key] === true) {
                return false;
            }

            return true;
        },
        visibleClass: function visibleClass(key) {
            var currentApp = this.tools.currentApp;

            if (currentApp && currentApp.panes && currentApp.panes[key] === false) {
                return 'is-hidden';
            }

            return 'is-visible';
        }
    }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'show-all-view',
    props: ['tools'],
    computed: {
        currentView: function currentView() {
            return this.tools.currentView;
        }
    }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaneView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PaneView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dummy_dummy_data__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'users-view',
    props: ['tools'],
    components: {
        PaneView: __WEBPACK_IMPORTED_MODULE_0__PaneView___default.a
    },
    computed: {
        patronGroups: function patronGroups() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dummy_dummy_data__["a" /* default */])('patron_groups');
        }
    }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Presets for data lists
 */

/* harmony default export */ __webpack_exports__["a"] = (function (tools) {

    var onChangeView = function onChangeView(key) {
        var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var pane = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        var obj = {
            key: key,
            title: row.breadcrumb,
            owner: row.owner,
            data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row, data, {
                pane: pane
            })
        };
        tools.changeView(obj);
    };

    var onChangeViewFull = function onChangeViewFull(row) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        tools.changeView(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            key: 'pane-full-view',
            title: row.breadcrumb,
            owner: row.owner
        }, options, {
            data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                hide: {
                    search: true,
                    results: true
                },
                pane: row
            }, data)
        }));
    };

    var replaceCurrentPreviewPaneData = function replaceCurrentPreviewPaneData(data) {
        tools.updateCurrentViewData({
            pane: data
        });
        if (tools.currentApp.panes.preview === false) {
            tools.actions.togglePane('preview', true);
        }
    };

    return {
        // Order table options
        order: {
            pane: {
                header: ['No.', '', 'Item ordered'],
                row: function row(_row) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row);
                        },
                        items: [_row.title, {
                            text: _row.items + "×",
                            classes: 'align-right'
                        }, _row.name]
                    };
                }
            },
            full: {
                header: ['No.', '', 'Item ordered'],
                row: function row(_row2) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row2);
                        },
                        items: [_row2.title, {
                            text: _row2.items + "×",
                            classes: 'align-right'
                        }, _row2.name]
                    };
                }
            },
            results: {
                header: ['No.', '', 'Item ordered'],
                row: function row(_row3) {
                    return {
                        onClick: function onClick() {
                            return replaceCurrentPreviewPaneData(_row3);
                        },
                        items: [_row3.title, {
                            text: _row3.items + "×",
                            classes: 'align-right'
                        }, _row3.name]
                    };
                }
            }
        },

        // Item table options
        item: {
            pane: {
                header: [],
                row: function row(_row4) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row4);
                        },
                        items: [_row4.title]
                    };
                }
            },
            full: {
                header: ['Name', 'Material Type', 'items', 'ok'],
                row: function row(_row5) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row5);
                        },
                        items: [_row5.name, _row5.material_type, _row5.sent, _row5.items]
                    };
                }
            },
            results: {
                header: ['Barcode', 'Instance', 'Location'],
                row: function row(_row6) {
                    return {
                        onClick: function onClick() {
                            return replaceCurrentPreviewPaneData(_row6);
                        },
                        items: [_row6.barcode, _row6.title, 'Main library › K.243.2']
                    };
                }
            }
        },

        // Instance table options
        instance: {
            pane: {
                header: [],
                row: function row(_row7) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row7);
                        },
                        items: [_row7.title]
                    };
                }
            },
            full: {
                header: ['Name', 'Vendor'],
                row: function row(_row8) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row8);
                        },
                        items: [_row8.title, _row8.vendor]
                    };
                }
            },
            results: {
                header: ['Name', 'Vendor'],
                row: function row(_row9) {
                    return {
                        onClick: function onClick() {
                            return replaceCurrentPreviewPaneData(_row9);
                        },
                        items: [_row9.title, _row9.vendor]
                    };
                }
            }
        },

        // Package table options
        package: {
            pane: {
                header: ['Package', 'Vendor'],
                row: function row(_row10) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row10);
                        },
                        items: [_row10.title, _row10.vendor]
                    };
                }
            },
            full: {
                header: ['Package', 'Vendor'],
                row: function row(_row11) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row11);
                        },
                        items: [_row11.title, _row11.vendor]
                    };
                }
            },
            results: {
                header: ['Package', 'Vendor'],
                row: function row(_row12) {
                    return {
                        onClick: function onClick() {
                            return replaceCurrentPreviewPaneData(_row12);
                        },
                        items: [_row12.title, _row12.vendor]
                    };
                }
            }
        },

        // User table options
        user: {
            pane: {
                header: ['Name', 'Status'],
                row: function row(_row13) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row13);
                        },
                        items: [_row13.lastname + ', ' + _row13.firstname, _row13.status]
                    };
                }
            },
            full: {
                header: ['Name', 'Status'],
                row: function row(_row14) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row14);
                        },
                        items: [_row14.lastname + ', ' + _row14.firstname, _row14.status]
                    };
                }
            },
            results: {
                header: ['Name', 'Status'],
                row: function row(_row15) {
                    return {
                        onClick: function onClick() {
                            return replaceCurrentPreviewPaneData(_row15);
                        },
                        sortBy: _row15.lastname,
                        items: [_row15.lastname + ', ' + _row15.firstname, _row15.status]
                    };
                }
            }
        },

        // User table options
        loan: {
            pane: {
                header: ['Title', 'Item status'],
                row: function row(_row16) {
                    return {
                        onClick: function onClick() {
                            return onChangeView('loan-details-view', _row16);
                        },
                        items: [_row16.item_name, _row16.item_status]
                    };
                }
            },
            full: {
                header: ['Title', 'Item status'],
                row: function row(_row17) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row17);
                        },
                        items: [_row17.item_name, _row17.item_status]
                    };
                }
            },
            results: {
                header: ['Title', 'Item status', 'Due date', 'Request queue', 'Barcode', 'Call number', 'Renewal count', 'Loan policy', 'Location'],
                row: function row(_row18) {
                    return {
                        onClick: null,
                        //  onClick: () => onChangeView('loan-details-view', row),
                        items: [_row18.item_name, _row18.item_status, _row18.due_date, _row18.request_queue, _row18.barcode, _row18.call_number, _row18.renewal_count, _row18.loan_policy, _row18.location]
                    };
                }
            }
        },

        // Loan actions
        loan_action: {
            pane: {
                header: ['Action date', 'Action', 'Due date', 'Item status', 'Desk', 'Source'],
                row: function row(_row19) {
                    return {
                        onClick: null,
                        items: [_row19.action_date, _row19.action, _row19.due_date, _row19.item_status, _row19.desk, _row19.source]
                    };
                }
            },
            full: {
                header: ['Action date', 'Action', 'Due date', 'Item status', 'Desk', 'Source'],
                row: function row(_row20) {
                    return {
                        onClick: null,
                        items: [_row20.action_date, _row20.action, _row20.due_date, _row20.item_status, _row20.desk, _row20.source]
                    };
                }
            },
            results: {
                header: ['Action date', 'Action', 'Due date', 'Item status', 'Desk', 'Source'],
                row: function row(_row21) {
                    return {
                        onClick: null,
                        items: [_row21.action_date, _row21.action, _row21.due_date, _row21.item_status, _row21.desk, _row21.source]
                    };
                }
            }
        },

        // Fee actions
        fee_action: {
            results: {
                header: ['Action date', 'Action', 'Balance', 'Trans. no.', 'Created at', 'Source', 'Notes'],
                row: function row(_row22) {
                    return {
                        onClick: null,
                        items: [_row22.action_date, _row22.action, _row22.balance, _row22.transaction_number, _row22.created_at, _row22.source, _row22.notes]
                    };
                }
            }
        },

        // Fees / fines
        fee: {
            pane: {
                header: ['Due date', 'Amount', 'Status'],
                row: function row(_row23) {
                    return {
                        onClick: function onClick() {
                            tools.changeView(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tools.currentView, {
                                key: 'users-view',
                                title: tools.currentView.data.pane.name
                            }), null, true);
                            onChangeView('fee-details-view', _row23);
                        },
                        items: [_row23.due_date, _row23.amount, _row23.fee_status]
                    };
                }
            },
            full: {
                header: [],
                row: function row(_row24) {
                    return {
                        onClick: function onClick() {
                            return onChangeViewFull(_row24);
                        },
                        items: [_row24.item_name, _row24.item_status]
                    };
                }
            },
            results: {
                header: ['Date', 'Fee/fine type', 'Charged', 'Remaining', 'Title', 'Item Type', 'Barcode', 'Call number', 'Fee/fine owner'],
                row: function row(_row25) {
                    return {
                        onClick: null,
                        //  onClick: () => onChangeView('loan-details-view', row),
                        items: [_row25.due_date, _row25.fee_type, _row25.amount, _row25.remaining, {
                            text: _row25.item_name,
                            classes: 'max-width-175'
                        }, _row25.item_type, _row25.barcode, _row25.call_number, _row25.fee_owner]
                    };
                }
            }
        }
    };
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_universal__ = __webpack_require__(120);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYjk2Zjk2OC0yNzliLTQwOWYtYTgyMC1iNzU1MjI4ZDcyMDAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzdBMTVFODY0RDQzMTFFN0EwOUFFMDlCOTJCMzg4REQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzdBMTVFODU0RDQzMTFFN0EwOUFFMDlCOTJCMzg4REQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4ZmIxNDliZi1iMThmLTRjM2UtYjgyZC1jYmE5ZmMwNTI2YjYiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDplOGM5NWMyYy01MmJjLTExN2EtYjk0OS1jZGEzOGQyN2ViZmQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz44xmD8AAAAtElEQVR42uyYMQ7DIAxFTcQxSshxOnfvxbJmz5y1N2nSe+BeIGQIIH2j7xEZ9PT9ZSy7TwiCFF4dFI8MAhZeCWStZIkK0dT0EHDJnvtxer7FEatkCc3U2hmQNgDSnjzUYEAredOmqV/f3+n5OoUq+dUU0gb5RaZODfKpkD2FCFTDQ0umf7wz/WaZ7u8L8D5XzkPmgDhT2wMquD3HB5cNBCKQOSDELSyWRl7EoXlIaeqr+AswAFzJWwxDbyrJAAAAAElFTkSuQmCC"

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE2Ljg5MiAxLjk4Mkg2Ljk3NEEyLjE0IDIuMTQgMCAwIDAgNC44MzYgNC4xMnYxNy4xNDhhLjc1Ljc1IDAgMCAwIDEuMjE4LjU4NWw1Ljg3OC00LjcxIDUuODc5IDQuNzFhLjc0NS43NDUgMCAwIDAgLjc5NC4wOTEuNzUuNzUgMCAwIDAgLjQyNS0uNjc2VjQuMTJhMi4xNCAyLjE0IDAgMCAwLTIuMTM4LTIuMTM4em0uNjM4IDE3LjcyNWwtNS4xMjktNC4xMDlhLjc0OC43NDggMCAwIDAtLjkzOCAwbC01LjEyOCA0LjEwOFY0LjEyYzAtLjM1Mi4yODYtLjYzOC42MzgtLjYzOGg5LjkxOGEuNjQuNjQgMCAwIDEgLjYzOS42Mzh2MTUuNTg3eiIvPjwvc3ZnPg=="

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMCAxMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzAgMTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGNpcmNsZSBjeD0iNS44IiBjeT0iNSIgcj0iMi42Ii8+CjxjaXJjbGUgY3g9IjE1IiBjeT0iNSIgcj0iMi42Ii8+CjxjaXJjbGUgY3g9IjI0LjIiIGN5PSI1IiByPSIyLjYiLz4KPC9zdmc+Cg=="

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIyLjg3MyA1LjE3NkgxMS4wMjRsLS44MDItMS44ODVhMi4wMjUgMi4wMjUgMCAwIDAtMS44NjctMS4yMzRIMy4zYy0uODE1IDAtMS41NDcuNDg0LTEuODY2IDEuMjM0TC40MzggNS42MzJhLjc0My43NDMgMCAwIDAtLjA2LjI5NHYxNS4yNjdjMCAuNDE0LjMzNi43NS43NS43NWgyMS43NDVhLjc1Ljc1IDAgMCAwIC43NS0uNzVWNS45MjZhLjc1Ljc1IDAgMCAwLS43NS0uNzV6bS0uNzUgMTUuMjY3SDEuODc3VjYuMDc5bC45MzctMi4yMDFhLjUyNy41MjcgMCAwIDEgLjQ4Ni0uMzIxaDUuMDU1YS41My41MyAwIDAgMSAuNDg3LjMyMWwuOTk2IDIuMzQxYS43NS43NSAwIDAgMCAuNjkuNDU3aDExLjU5NHYxMy43Njd6Ii8+PC9zdmc+"

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIwLjA4MyAxMy4zODF2LTIuNDE3YTguMDk1IDguMDk1IDAgMCAwLTUuNDA3LTcuNjIxQzE0LjUzMiAxLjk5NCAxMy4zODYuOTQgMTIgLjk0UzkuNDY4IDEuOTk0IDkuMzI0IDMuMzQzYTguMDk1IDguMDk1IDAgMCAwLTUuNDA3IDcuNjIxdjIuNDE3YTYuNTggNi41OCAwIDAgMS0yLjI0NSA0Ljk0MS43NTEuNzUxIDAgMCAwIC40OTUgMS4zMTNoNS45MDlBNC4wMDEgNC4wMDEgMCAwIDAgMTIgMjIuODhhNCA0IDAgMCAwIDMuOTI0LTMuMjQ1aDUuOTA5YS43NS43NSAwIDAgMCAuNDk1LTEuMzEzIDYuNTc5IDYuNTc5IDAgMCAxLTIuMjQ1LTQuOTQxem0tNC44MzggNC43NTVhLjc1Ljc1IDAgMCAwLS43NS43NUEyLjQ5OCAyLjQ5OCAwIDAgMSAxMiAyMS4zODFhMi40OTggMi40OTggMCAwIDEtMi40OTUtMi40OTUuNzUuNzUgMCAwIDAtLjc1LS43NUgzLjg2MmE4LjA2OCA4LjA2OCAwIDAgMCAxLjU1NS00Ljc1NXYtMi40MTdjMC0yLjk2MyAyLTUuNTc0IDQuODY0LTYuMzQ4LjM2NS0uMDk5LjU5NC0uNDk3LjU0MS0uODcyLS4wMDUtLjAzNy0uMDEzLS4wNzQtLjAxMy0uMTEzYTEuMTkyIDEuMTkyIDAgMCAxIDIuMzgyIDBjMCAuMDM5LS4wMDguMDc2LS4wMi4xNmEuNzUxLjc1MSAwIDAgMCAuNTQ3LjgyNiA2LjU5IDYuNTkgMCAwIDEgNC44NjQgNi4zNDh2Mi40MTdjMCAxLjcyMS41NTMgMy4zODMgMS41NTUgNC43NTVoLTQuODkyeiIvPjwvc3ZnPg=="

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MiA0MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDIgNDI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMDEwMjAyO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTM5LjQsMzdMMzAsMjcuN2M0LjktNiw0LjUtMTQuOS0xLjEtMjAuNUMyNiw0LjIsMjIuMSwyLjYsMTgsMi42Yy00LjEsMC04LDEuNi0xMC45LDQuNQoJQzQuMiwxMCwyLjYsMTMuOSwyLjYsMThzMS42LDgsNC41LDEwLjljMi45LDIuOSw2LjgsNC41LDEwLjksNC41YzMuNiwwLDYuOS0xLjIsOS43LTMuNGw5LjMsOS4zTDM5LjQsMzd6IE0xOCwzMC4xCgljLTMuMiwwLTYuMy0xLjMtOC41LTMuNUM3LjIsMjQuMyw2LDIxLjMsNiwxOHMxLjMtNi4zLDMuNS04LjVDMTEuOCw3LjIsMTQuOCw2LDE4LDZjMy4yLDAsNi4zLDEuMyw4LjUsMy41YzQuNyw0LjcsNC43LDEyLjQsMCwxNy4xCglDMjQuMywyOC44LDIxLjMsMzAuMSwxOCwzMC4xeiIvPgo8L3N2Zz4K"

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(451),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(445),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(424),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(428),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(440),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(464),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ab5519b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(449),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(231)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(441),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(454),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(430),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(434),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(422),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(427),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(420),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(452),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(423),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main app-main--fee-details view"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "hasBackButton": true,
      "title": "Fee/fine Details"
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [(false) ? _c('pre', [_vm._v("            " + _vm._s(JSON.stringify(_vm.currentView, null, 4)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('ui-padding', [_c('div', {
    staticClass: "fee-details__buttons"
  }, [_c('ui-button', {
    attrs: {
      "title": "Pay"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Waive"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Refund"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Transfer"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Error"
    }
  })], 1)]), _vm._v(" "), _c('ui-padding', [_c('ui-details', {
    style: ({
      padding: 0
    }),
    attrs: {
      "size": "w250 no-padding",
      "list": [{
          label: 'Patron',
          value: ((_vm.user.lastname) + ", " + (_vm.user.firstname) + " (" + (_vm.user.patron_group) + ")"),
        },
        'break',
        {
          label: 'Fee/fine type',
          value: _vm.fee.fee_type,
        },
        {
          label: 'Fee/fine owner',
          value: _vm.fee.fee_owner,
        },
        {
          label: 'Charge date',
          value: _vm.fee.charge_date,
        },
        {
          label: 'Original fee/fine',
          value: _vm.fee.amount,
        },
        {
          label: 'Outstanding amount',
          value: _vm.fee.remaining,
        },
        'break',
        {
          label: 'Item type',
          value: _vm.fee.item_type,
        },
        {
          label: 'Title',
          value: _vm.fee.item_name,
        },
        {
          label: 'Barcode',
          value: _vm.fee.barcode,
        },
        {
          label: 'Call number',
          value: _vm.fee.call_number,
        },
        {
          label: 'Location',
          value: _vm.fee.fee_owner,
        } ]
    }
  }), _vm._v(" "), _c('ui-link', {
    on: {
      "click": _vm.viewLoanDetails
    }
  }, [_vm._v("View loan details")])], 1), _vm._v(" "), _c('ui-padding', [_c('ui-data-list', {
    staticClass: "col-min-120",
    attrs: {
      "preset": "fee_action",
      "type": "results",
      "tools": _vm.tools,
      "maxItems": 4,
      "minItems": 2,
      "cache": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view--loans"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "hasBackButton": true,
      "title": ("Loans - Borrower: " + (_vm.user.lastname) + ", " + (_vm.user.firstname) + " (" + (_vm.user.patron_group) + ")")
    }
  }), _vm._v(" "), _c('ui-padding', [_c('div', {
    staticClass: "loan-details__buttons"
  }, [_c('ui-search-field', {
    staticClass: "loan-details__search-field",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "loan-details__results"
  }, [_vm._v("12 results")]), _vm._v(" "), _c('div', {
    staticClass: "loan-details__buttons__right-align"
  }, [_c('ui-button', {
    attrs: {
      "title": "Renew"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Change due date"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Claim returned"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Lost"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Cancel loan"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ui-padding', {
    staticClass: "overflow-auto"
  }, [_c('ui-data-list', {
    staticClass: "col-min-120",
    attrs: {
      "hasCheckBox": true,
      "preset": "loan",
      "type": "results",
      "tools": _vm.tools,
      "maxItems": 12,
      "minItems": 3,
      "cache": true,
      "includeInList": {
        user: _vm.user
      },
      "dropdown": _vm.dropdownOptions
    }
  })], 1), _vm._v(" "), _c('pre', [_vm._v("        " + _vm._s( /** JSON.stringify(currentView, null, 4) */ ) + "\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ui-padding']
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-all-view"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "title": _vm.currentView.data.headerTitle,
      "subtitle": _vm.currentView.data.headerSub,
      "hasBackButton": true,
      "appIconKey": _vm.currentView.data.preset
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('ui-data-list', {
    attrs: {
      "preset": _vm.currentView.data.preset,
      "type": "full",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-breadcrumbs"
  }, [_c('ul', [_c('li', {
    staticClass: "app-breadcrumbs__item"
  }, [_c('button', {
    class: ['app-breadcrumbs__context-button', _vm.showBreadcrumbs ? 'has-breadcrumbs' : '']
  }, [_c('app-icon-button', {
    class: ['app-switcher__button--svg', 'app-breadcrumbs__context-button__icon'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(66)
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    attrs: {
      "prototype": _vm.currentApp
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "app-breadcrumbs__context-button__label"
  }, [_vm._v(_vm._s(_vm.currentApp.name))])], 1), _vm._v(" "), (_vm.showContextSwitcherButton && _vm.showBreadcrumbs) ? _c('button', {
    class: ['app-breadcrumbs__context-switcher-button', _vm.showAppSwitcher ? 'active' : null],
    on: {
      "click": function () { return _vm.tools.actions.toggleContextSwitcher(); }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#010202",
      "d": "M21.248 10.171h-2.29v-2.29a.75.75 0 0 0-.75-.75h-2.29V4.84a.75.75 0 0 0-.75-.75H2.752a.75.75 0 0 0-.75.75v8.238c0 .414.336.75.75.75h2.09c.071 0 .135-.022.2-.04v2.33c0 .414.336.75.75.75h2.09c.071 0 .135-.022.2-.04v2.33c0 .414.336.75.75.75h12.417a.75.75 0 0 0 .75-.75V10.92a.75.75 0 0 0-.751-.749zM5.042 7.881v4.489c-.065-.018-.129-.04-.2-.04h-1.34V5.59h10.917v1.54H5.792a.751.751 0 0 0-.75.751zm3.04 3.04v4.489c-.065-.018-.129-.04-.2-.04h-1.34V8.631h10.917v1.54H8.832a.75.75 0 0 0-.75.75zm12.416 7.488H9.582v-6.738h10.917v6.738z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.data), function(breadcrumb, index) {
    return (_vm.data.length && !_vm.showAppSwitcher && _vm.showBreadcrumbs) ? _c('li', {
      staticClass: "app-breadcrumbs__item"
    }, [(!Array.isArray(breadcrumb)) ? _c('button', {
      staticClass: "app-breadcrumbs__button",
      attrs: {
        "title": breadcrumb.title
      },
      on: {
        "click": function () { return _vm.updateBreadcrumbs(breadcrumb.i); }
      }
    }, [_vm._v(_vm._s(_vm.concat(breadcrumb.title)))]) : _vm._e(), _vm._v(" "), (Array.isArray(breadcrumb)) ? [_c('button', {
      staticClass: "app-breadcrumbs__dropdown_toggle",
      on: {
        "click": _vm.toggleDropdown
      }
    }, [_c('img', {
      staticClass: "app-breadcrumbs__dots",
      attrs: {
        "src": __webpack_require__(368),
        "alt": ""
      }
    })]), _vm._v(" "), _c('ul', {
      ref: "dropdown",
      refInFor: true,
      class: ['app-breadcrumbs__dropdown', _vm.dropdownVisible ? 'active' : null]
    }, _vm._l((breadcrumb), function(subMenuBreadcrumb) {
      return _c('li', {
        staticClass: "app-breadcrumbs__dropdown__item"
      }, [_c('button', {
        staticClass: "app-breadcrumbs__dropdown__item__button",
        on: {
          "click": function () { return _vm.updateBreadcrumbs(subMenuBreadcrumb.i); }
        }
      }, [_vm._v("\n                            " + _vm._s(subMenuBreadcrumb.title) + "\n                        ")])])
    }))] : _vm._e(), _vm._v(" "), _c('svg', {
      staticClass: "app-breadcrumbs__arrow",
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 15 22",
        "enable-background": "new 0 0 15 22",
        "xml:space": "preserve"
      }
    }, [_c('polygon', {
      attrs: {
        "points": "1.411,21.907 0.528,21.498 5.396,11 0.528,0.502 1.411,0.093 6.469,11 "
      }
    })])], 2) : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'item') ? _c('div', {
    staticClass: "pane-template"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.item.title,
      "subtitle": _vm.item.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.item.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-details', {
    attrs: {
      "title": _vm.item.name,
      "list": [{
          label: 'Status',
          value: _vm.item.status,
        },
        {
          label: 'Barcode',
          value: _vm.item.barcode,
        },
        {
          label: 'Loan type (permanent)',
          value: _vm.item.loan_type_permanent,
        },
        {
          label: 'Location (permanent)',
          value: _vm.item.location_type_permanent,
        },
        {
          label: 'Call Number',
          value: _vm.item.call_number,
        },
        {
          label: 'Material type',
          value: _vm.item.material_type,
        },
        {
          label: 'Loan type (temporary)',
          value: _vm.item.loan_type_temporary,
        },
        {
          label: 'Location (temporary)',
          value: _vm.item.location_type_temporary,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related orders",
      "preset": "order",
      "itemCount": 1,
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related instances",
      "itemCount": _vm.item.instanceCount,
      "preset": "instance",
      "tools": _vm.tools
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'instance') ? _c('div', {
    staticClass: "pane-template"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.instance.title,
      "subtitle": _vm.instance.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.instance.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-details', {
    attrs: {
      "cover": "cover",
      "title": _vm.instance.name,
      "list": [{
          label: 'Standard Identifiers',
          value: _vm.instance.identifiers,
        },

        {
          label: 'Source',
          value: _vm.instance.source,
        },
        {
          label: 'Subject(s)',
          value: _vm.instance.subjects,
        },
        {
          label: 'Edition',
          value: _vm.instance.edition,
        },
        {
          label: 'Publisher',
          value: _vm.instance.publisher,
        },
        {
          label: 'Publication date',
          value: _vm.instance.publication_date,
        },
        {
          label: 'Resource type',
          value: _vm.instance.resource_type,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related packages",
      "itemCount": _vm.instance.packageCount,
      "preset": "package",
      "tools": _vm.tools
    }
  }), _vm._v(" "), (false) ? _c('pane-section', {
    attrs: {
      "title": "Related orders",
      "preset": "order",
      "tools": _vm.tools
    }
  }) : _vm._e(), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related items",
      "preset": "item",
      "tools": _vm.tools
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "ui-search-field",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Search..."
    },
    domProps: {
      "value": _vm.inputValue
    }
  })
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-tabs",
    attrs: {
      "id": "tabs"
    }
  }, _vm._l((_vm.routes), function(route) {
    return _c('transition-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (route.routeKey === _vm.currentRoute),
        expression: "route.routeKey === currentRoute"
      }],
      key: route.routeKey,
      staticClass: "app-tabs__inner",
      attrs: {
        "name": "tabs-transition",
        "tag": "div"
      }
    }, _vm._l((route.appStateHistory), function(tab) {
      return _c('button', {
        key: tab.stackId,
        class: ['app-tabs__item', {
          'active': _vm.isActive(tab)
        }, {
          'can-delete': _vm.canDeleteTabs
        }],
        attrs: {
          "id": tab.stackId
        },
        on: {
          "click": function () { return _vm.onSwitch(tab); }
        }
      }, [_c('div', {
        staticClass: "app-tabs__item__inner"
      }, [_c('span', [_vm._v(_vm._s(_vm.visibleStackItem(tab).title))]), _vm._v(" "), _c('svg', {
        staticClass: "app-tabs__close",
        attrs: {
          "version": "1.1",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "x": "0px",
          "y": "0px",
          "viewBox": "0 0 24 24",
          "enable-background": "new 0 0 24 24",
          "xml:space": "preserve"
        },
        on: {
          "click": function () { return _vm.closeTab(tab); }
        }
      }, [_c('path', {
        attrs: {
          "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
        }
      })])])])
    }))
  }))
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentView) ? _c('main', {
    class: ['view', ("view--" + (_vm.tools.currentView.key))]
  }, [(_vm.showView('basic-view')) ? _c('basic-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "basic"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('pane-view')) ? _c('pane-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "pane-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('orders-view')) ? _c('orders-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "orders-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('packages-view')) ? _c('packages-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "packages-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('instances-view')) ? _c('instances-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "instances-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('items-view')) ? _c('items-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "items-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('users-view')) ? _c('users-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "users-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('pane-full-view')) ? _c('pane-full-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "pane-full-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('show-all-view')) ? _c('show-all-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "show-all-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('loans-view')) ? _c('loans-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "loans-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('loan-details-view')) ? _c('loan-details-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "loan-details-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('fees-view')) ? _c('fees-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "fees-view"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showView('fee-details-view')) ? _c('fee-details-view', {
    attrs: {
      "tools": _vm.tools,
      "viewKey": "fee-details-view"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: ['ui-data-list', _vm.preset ? ("ui-data-list--" + _vm.preset) : null, _vm.type ? ("ui-data-list--" + _vm.type) : null]
  }, [_c('table', {
    staticClass: "ui-data-list__table"
  }, [(_vm.tableHeader && _vm.tableHeader.length) ? _c('thead', [_c('tr', [(_vm.hasCheckBox) ? _c('th', {
    staticClass: "ui-data-list__col__checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHeader), function(row) {
    return _c('th', [_vm._v(_vm._s(row))])
  }), _vm._v(" "), (typeof _vm.dropdown !== 'undefined') ? _c('th', {
    staticClass: "ui-data-list__col__dropdown no-overflow-hidden"
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.list.length) ? _c('tbody', _vm._l((_vm.cached), function(row, index) {
    return _c('tr', {
      class: [_vm.selectedClass(row, index), !row.onClick ? 'no-click' : ''],
      on: {
        "click": function () { return _vm.onClick(row); }
      }
    }, [(_vm.hasCheckBox) ? _c('td', {
      staticClass: "ui-data-list__col__checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      }
    })]) : _vm._e(), _vm._v(" "), (Array.isArray(row)) ? _vm._l((row), function(column, columnIndex) {
      return _c('td', {
        class: [typeof column === 'number' ? 'monospaced' : '']
      }, [(columnIndex === 0) ? _c('app-icon', {
        attrs: {
          "tools": _vm.tools,
          "name": _vm.preset
        }
      }) : _vm._e(), _vm._v("\n                        " + _vm._s(column) + "\n                    ")], 1)
    }) : _vm._l((row.items), function(column, columnIndex) {
      return _c('td', {
        class: [typeof column === 'number' ? 'monospaced' : '', typeof column === 'object' && column.classes ? column.classes : null]
      }, [(columnIndex === 0) ? _c('app-icon', {
        attrs: {
          "tools": _vm.tools,
          "name": _vm.preset
        }
      }) : _vm._e(), _vm._v("\n                        " + _vm._s((column && column.text) ? column.text : column) + "\n                    ")], 1)
    }), _vm._v(" "), (typeof _vm.dropdown !== 'undefined') ? _c('td', {
      staticClass: "ui-data-list__col__dropdown no-overflow-hidden"
    }, [_c('ui-dropdown', {
      attrs: {
        "list": _vm.dropdown(row)
      }
    })], 1) : _vm._e()], 2)
  })) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-headline"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pane-header__search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pane-header__search__icon",
    attrs: {
      "src": __webpack_require__(371),
      "alt": ""
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'order') ? _c('div', {
    staticClass: "pane-template"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.order.title,
      "subtitle": _vm.order.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.order.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('order-details', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related items",
      "preset": "item",
      "itemCount": 1,
      "tools": _vm.tools
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ui-dropdown', _vm.open ? 'open' : 'closed']
  }, [_vm._t("default", [_c('button', {
    staticClass: "ui-dropdown__button",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), (_vm.open) ? _c('div', {
    class: ['ui-dropdown__menu']
  }, [_c('ui-tab-list', {
    attrs: {
      "tabs": _vm.list,
      "callback": _vm.onClick
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('mode-switcher', {
    attrs: {
      "backButtonBehaviors": _vm.backButtonBehaviors,
      "currentBackButtonBehavior": _vm.currentBackButtonBehavior,
      "onChangeBackButtonBehavior": _vm.changeBackButtonBehavior,
      "currentMode": _vm.currentMode,
      "availableModes": _vm.availableModes,
      "onChangeMode": _vm.changeMode,
      "switcherLayouts": _vm.switcherLayouts,
      "currentSwitcherLayout": _vm.currentSwitcherLayout,
      "onChangeSwitcherLayout": _vm.changeSwitcherLayout,
      "currentShowAllBehavior": _vm.currentShowAllBehavior,
      "showAllBehaviors": _vm.showAllBehaviors,
      "onChangeShowAllBehavior": _vm.changeShowAllBehavior,
      "currentAltClickMode": _vm.currentAltClickMode,
      "altClickModes": _vm.altClickModes,
      "onChangeAltClickMode": _vm.changeAltClickMode
    }
  }), _vm._v(" "), (_vm.currentSwitcherLayout === 'boxes') ? _c('app-context-switcher', {
    attrs: {
      "appHistory": _vm.appSwitcherItems,
      "show": _vm.showAppSwitcher,
      "tools": _vm.tools
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentApp.dropdown) ? _c('div', {
    staticClass: "app-vignette",
    on: {
      "click": _vm.closeDropdown
    }
  }) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "app-header"
  }, [_c('app-breadcrumbs', {
    attrs: {
      "data": _vm.breadcrumbsWithDropdown,
      "currentApp": _vm.currentApp,
      "updateBreadcrumbs": _vm.updateBreadcrumbs,
      "toggleDropdown": _vm.toggleDropdown,
      "dropdownVisible": _vm.currentApp.dropdown,
      "tools": _vm.tools,
      "showBreadcrumbs": _vm.currentSwitcherLayout === 'boxes',
      "showAppSwitcher": _vm.showAppSwitcher
    }
  }), _vm._v(" "), (_vm.currentSwitcherLayout === 'tabs') ? _c('app-tabs', {
    attrs: {
      "appHistory": _vm.currentApp.appStateHistory,
      "tools": _vm.tools
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "app-header__end"
  }, [_c('div', {
    staticClass: "app-header__divider"
  }), _vm._v(" "), _c('section', {
    staticClass: "app-switcher"
  }, [_vm._l((_vm.routes), function(route, key) {
    return _c('app-icon-button', {
      key: key,
      class: ['app-switcher__button', _vm.currentRouteKey === key ? 'selected' : null],
      attrs: {
        "disabled": !route.appState,
        "prototype": route
      },
      on: {
        "click": function () {
          if (!route.appState) {
            return null;
          }
          return _vm.changeRoute(key);
        }
      }
    })
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(66)
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "app-header__divider"
  }), _vm._v(" "), _c('section', {
    staticClass: "app-switcher"
  }, [_c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(367)
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(370)
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(369)
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(66)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app-header__divider"
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button'],
    attrs: {
      "prototype": {
        icon: __webpack_require__(372)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('view-container', {
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('app-toasts', {
    attrs: {
      "toasts": _vm.toasts,
      "tools": _vm.tools
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui-button",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [(_vm.iconLeft) ? _c('ui-icon', {
    staticClass: "ui-button__icon left",
    attrs: {
      "name": _vm.iconLeft
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._t("title", [_vm._v(_vm._s(_vm.title))], {
    tag: "span"
  })]), _vm._v(" "), (_vm.iconRight) ? _c('ui-icon', {
    staticClass: "ui-button__icon left",
    attrs: {
      "name": _vm.iconRight
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui-details"
  }, [(_vm.title) ? _c('ui-headline', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "ui-details-meta"
  }, [_c('section', {
    staticClass: "ui-details-coversection"
  }, [(_vm.cover) ? _c('div', {
    class: ['ui-details-cover', _vm.image ? 'has-image' : ''],
    style: (_vm.coverStyle)
  }) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "ui-details-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      class: ['ui-details-list__item', _vm.size, item === 'break' ? 'break' : '']
    }, [(item !== 'break') ? [_c('div', {
      staticClass: "ui-details-list__item__label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "ui-details-list__item__value"
    }, [(Array.isArray(item.value)) ? _vm._l((item.value), function(text) {
      return _c('div', [_vm._v(_vm._s(text))])
    }) : [(item.isLink || item.onClick) ? [_c('ui-link', {
      on: {
        "click": item.onClick
      }
    }, [_vm._v(_vm._s(item.value))])] : [_vm._v("\n                                " + _vm._s(item.value) + "\n                            ")]]], 2)] : _vm._e()], 2)
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pane-view', {
    attrs: {
      "tools": _vm.tools
    }
  }, [_c('template', {
    slot: "search-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Search and filter",
      "tools": _vm.tools,
      "hasCloseSearchIcon": true
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-search-field', {
    staticClass: "pane__search-bar",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Workflow",
      "items": ['Created', 'Awaiting review', 'Awaiting approval', 'Approved', 'Submitted']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Order Status",
      "items": ['Order sent', 'Vendor confirm', 'Received', 'Routed for shelving']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Payment Status",
      "items": ['No invoice', 'Created', 'Sent', 'Received', 'Approved']
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "results-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Instances",
      "subtitle": "209 search results",
      "hasSearchIcon": true,
      "tools": _vm.tools,
      "appIconKey": "instance"
    }
  }, [_c('ui-button', {
    attrs: {
      "title": "New",
      "iconLeft": "plus"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-data-list', {
    attrs: {
      "preset": "instance",
      "type": "results",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "preview-pane"
  }, [_c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasPane) ? _c('main', {
    class: ['pane-preview-container']
  }, [_c('pane-order-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-package-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-item-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-instance-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  }), _vm._v(" "), _c('pane-user-template', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": _vm.hideHeader
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-toast-container"
  }, [_c('transition', {
    attrs: {
      "name": "toast-animation"
    }
  }, [(_vm.toast) ? _c('div', {
    staticClass: "app-toast"
  }, [_vm._m(0), _vm._v(" "), _c('app-icon', {
    staticClass: "app-toast__app-icon",
    attrs: {
      "name": _vm.toast.icon,
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-toast__text"
  }, [_vm._v(_vm._s(_vm.toast.title))])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "app-toast__icon",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.11,12.382c0.101-0.244,0.101-0.52,0-0.764c-0.051-0.123-0.124-0.233-0.217-0.326L14.05,6.449\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L15.773,11H5.813c-0.552,0-1,0.447-1,1s0.448,1,1,1h9.96l-3.137,3.138\n                    c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l4.843-4.844\n                    C18.985,12.615,19.059,12.504,19.11,12.382z"
    }
  })])
}]}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "pane-content"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main app-main--loan-details view"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "hasBackButton": true,
      "title": "Loan Details"
    }
  }), _vm._v(" "), (false) ? _c('pre', [_vm._v("        " + _vm._s(JSON.stringify(_vm.currentView, null, 4)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('ui-padding', [_c('div', {
    staticClass: "loan-details__buttons"
  }, [_c('ui-button', {
    attrs: {
      "title": "Renew"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Change due date"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Claim returned"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Lost"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Cancel loan"
    }
  })], 1)]), _vm._v(" "), _c('ui-padding', [_c('ui-details', {
    attrs: {
      "title": _vm.loan.title,
      "size": "w250",
      "list": _vm.details
    }
  })], 1), _vm._v(" "), _c('ui-padding', [_c('ui-data-list', {
    staticClass: "col-min-120",
    attrs: {
      "preset": "loan_action",
      "type": "results",
      "tools": _vm.tools,
      "maxItems": 4,
      "minItems": 2,
      "cache": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui-checklist"
  }, [_c('h4', {
    staticClass: "ui-checklist-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "ui-checklist-checkbox"
    }, [_c('label', {
      staticClass: "ui-checklist-checkbox--label"
    }, [_c('input', {
      staticClass: "ui-checklist-checkbox--box",
      attrs: {
        "type": "checkbox"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ui-checklist-checkbox--title"
    }, [_vm._v(_vm._s(item))])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pane-view', {
    attrs: {
      "tools": _vm.tools
    }
  }, [_c('template', {
    slot: "search-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Search and filter",
      "tools": _vm.tools,
      "hasCloseSearchIcon": true
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-search-field', {
    staticClass: "pane__search-bar",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Workflow",
      "items": ['Created', 'Awaiting review', 'Awaiting approval', 'Approved', 'Submitted']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Order Status",
      "items": ['Order sent', 'Vendor confirm', 'Received', 'Routed for shelving']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Payment Status",
      "items": ['No invoice', 'Created', 'Sent', 'Received', 'Approved']
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "results-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Packages",
      "subtitle": "106 search results",
      "hasSearchIcon": true,
      "tools": _vm.tools,
      "appIconKey": "package"
    }
  }, [_c('ui-button', {
    attrs: {
      "iconLeft": "plus",
      "title": "New",
      "tools": _vm.tools
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-data-list', {
    attrs: {
      "preset": "package",
      "type": "results",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "preview-pane"
  }, [_c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: ['app-context-switcher-preview', _vm.active ? 'active' : null],
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "app-context-switcher-preview__inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(361)
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view--loans"
  }, [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "hasBackButton": true,
      "title": ("Fees/fines - Patron: " + (_vm.user.lastname) + ", " + (_vm.user.firstname) + " (" + (_vm.user.patron_group) + ")")
    }
  }), _vm._v(" "), (false) ? _c('pre', [_vm._v("        " + _vm._s(JSON.stringify(_vm.currentView, null, 4)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('ui-padding', [_c('div', {
    staticClass: "loan-details__buttons"
  }, [_c('ui-search-field', {
    staticClass: "loan-details__search-field",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "loan-details__results"
  }, [_vm._v("12 records found")]), _vm._v(" "), _c('div', {
    staticClass: "loan-details__buttons__right-align"
  }, [_c('ui-button', {
    attrs: {
      "title": "Charge manual fee/fine"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Pay"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Waive"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Refund"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "title": "Transfer"
    }
  })], 1)], 1)]), _vm._v(" "), _c('ui-padding', {
    staticClass: "overflow-auto"
  }, [_c('ui-data-list', {
    staticClass: "col-min-120",
    attrs: {
      "hasCheckBox": true,
      "preset": "fee",
      "type": "results",
      "tools": _vm.tools,
      "maxItems": 12,
      "minItems": 3,
      "cache": true,
      "includeInList": {
        user: _vm.user
      },
      "dropdown": _vm.dropdownOptions
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "skeleton-lines"
  }, _vm._l((_vm.lines), function(line) {
    return _c('li', {
      staticClass: "skeleton-lines__line"
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: ['ui-icon', ("fa fa-" + _vm.name)]
  })
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inventory-block"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "inventory-block--titleinfo"
  }, [_vm._v("Resource type: Book ISBN: 93423-3432-4234-2 Paper.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "inventory-block--bottom"
  }, [_c('section', [_c('ui-icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inventory-block--top"
  }, [_c('section', {
    staticClass: "inventory-block--title"
  }, [_vm._v("BOOK NAME")]), _vm._v(" "), _c('section', {
    staticClass: "inventory-block--source"
  }, [_vm._v("Source: Gyldendal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inventory-block--tableblock"
  }, [_c('h4', {
    staticClass: "inventory-block--availability"
  }, [_vm._v("Physical availability")]), _vm._v(" "), _c('section', [_c('section', [_vm._v("TABLE HERE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("View more")])])
}]}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.icon) ? _c('img', {
    staticClass: "app-icon",
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "app-switcher-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "app-context-switcher"
  }, [_c('div', {
    staticClass: "app-context-switcher__inner"
  }, _vm._l((_vm.appHistory), function(preview, index) {
    return _c('app-context-switcher-preview', {
      key: index,
      class: [preview.stackId === _vm.currentStackId ? _vm.activeClasses : ''],
      attrs: {
        "preview": preview,
        "tools": _vm.tools,
        "active": preview.stackId === _vm.currentStackId,
        "id": preview.stackId
      },
      on: {
        "click": function () { return _vm.switchContext(preview); }
      }
    })
  }))])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('pane-header', {
    attrs: {
      "tools": _vm.tools,
      "title": _vm.tools.currentView.data.pane.title,
      "subtitle": _vm.tools.currentView.data.pane.sub,
      "hasBackButton": true,
      "appIconKey": _vm.tools.currentView.data.pane.type
    }
  }), _vm._v(" "), _c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools,
      "hideHeader": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui-link",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smooth-scroll-container"
  }, [_c('div', {
    staticClass: "pane-content-with-sidebar"
  }, [_c('div', {
    staticClass: "pane-content-with-sidebar__left"
  }, [_c('ui-tab-list', {
    staticClass: "pane-content-with-sidebar__left__fixed",
    attrs: {
      "tabs": _vm.tabs,
      "active": _vm.active
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pane-content-with-sidebar__right"
  }, [_c('pane-content', [_vm._t("default")], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main app-main--search view"
  }, [_c('transition', {
    attrs: {
      "name": "vignette-transition"
    }
  }, [(_vm.showVignette) ? _c('div', {
    staticClass: "pane-vignette pane-vignette--search",
    on: {
      "click": _vm.onVignetteClick
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showPane('search')) ? _c('section', {
    class: ['pane pane--search pane--start', _vm.visibleClass('search')]
  }, [_vm._t("search-pane")], 2) : _vm._e(), _vm._v(" "), (_vm.showPane('results')) ? _c('section', {
    class: ['pane pane--results', _vm.visibleClass('results')]
  }, [_vm._t("results-pane")], 2) : _vm._e(), _vm._v(" "), (_vm.showPane('preview')) ? _c('section', {
    class: [_vm.previewPaneClass, 'pane', 'pane--preview', 'pane--end', _vm.previewFullWidth ? 'pane--full-width' : null, _vm.visibleClass('preview')]
  }, [_vm._t("preview-pane")], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pane-view', {
    attrs: {
      "tools": _vm.tools
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('template', {
    slot: "preview-pane"
  }, [_c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('template', {
    slot: "search-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Search and filter",
      "tools": _vm.tools,
      "hasCloseSearchIcon": true
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-search-field', {
    staticClass: "pane__search-bar",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Workflow",
      "items": ['Created', 'Awaiting review', 'Awaiting approval', 'Approved', 'Submitted']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Order Status",
      "items": ['Order sent', 'Vendor confirm', 'Received', 'Routed for shelving']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Payment Status",
      "items": ['No invoice', 'Created', 'Sent', 'Received', 'Approved']
    }
  })], 1)], 1)], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('template', {
    slot: "results-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Orders",
      "subtitle": "86 search results",
      "hasSearchIcon": true,
      "tools": _vm.tools,
      "appIconKey": "order"
    }
  }, [_c('ui-button', {
    attrs: {
      "title": "New",
      "iconLeft": "plus"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-data-list', {
    attrs: {
      "preset": "order",
      "type": "results",
      "tools": _vm.tools,
      "itemCount": 86
    }
  })], 1)], 1)], 1)
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: ['pane-section', _vm.collapsed ? 'collapsed' : '']
  }, [_c('section', {
    staticClass: "pane-section__header"
  }, [_c('section', {
    staticClass: "pane-section--left",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('button', {
    staticClass: "pane-section--icon"
  }, [_c('ui-icon', {
    attrs: {
      "name": _vm.collapsed ? 'chevron-down' : 'chevron-up'
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "pane-section--title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))], {
    tag: "span"
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "pane-section--right"
  }, [_c('div', {
    staticClass: "hidden-when-collapsed"
  }, [_vm._t("pane-header-right"), _vm._v(" "), (typeof _vm.hasButton === 'undefined' || _vm.hasButton === true) ? _c('ui-button', {
    attrs: {
      "title": "View all"
    },
    on: {
      "click": _vm.onViewAll
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('section', {
    class: ['pane-section__content', _vm.hasSlot ? 'has-slot' : '']
  }, [_vm._t("default", [_c('ui-data-list', {
    attrs: {
      "header": _vm.tableHeader,
      "preset": _vm.preset,
      "type": "pane",
      "tools": _vm.tools,
      "itemCount": _vm.itemCount,
      "maxItems": _vm.itemCountMax,
      "minItems": _vm.itemCountMin,
      "cache": false,
      "includeInList": _vm.includeInList
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "app-icon-button focusable",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "app-icon-button__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.prototype.icon,
      "alt": _vm.prototype.title
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: ['ui-tab-list']
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      class: ['ui-tab-list__item', _vm.active === index ? 'active' : '']
    }, [_c('a', {
      class: ['ui-tab-list__item__button'],
      attrs: {
        "href": tab.href
      },
      on: {
        "click": function () { return _vm.handleClick(tab); }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.title))])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pane-view', {
    attrs: {
      "tools": _vm.tools
    }
  }, [_c('template', {
    slot: "search-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Search and filter",
      "hasCloseSearchIcon": true,
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-search-field', {
    staticClass: "pane__search-bar",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Material Type",
      "items": ['Book', 'DVD', 'CD', 'Magazine', 'Room Key']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Circulation Status",
      "items": ['Checked out', 'Checked in', 'On hold']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Payment Status",
      "items": ['No invoice', 'Created', 'Sent', 'Received', 'Approved']
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "results-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Items",
      "subtitle": "201 items",
      "hasSearchIcon": true,
      "tools": _vm.tools,
      "appIconKey": "item"
    }
  }, [_c('ui-button', {
    attrs: {
      "title": "New",
      "iconLeft": "plus"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-data-list', {
    attrs: {
      "preset": "item",
      "type": "results",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "preview-pane"
  }, [_c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view--basic"
  }, [_vm._v("\n    This displays some content for the view with key \"info\". (" + _vm._s(_vm.tools.currentView.title) + ")\n    "), (_vm.tools.currentView.data.hasPane) ? _c('div', [_vm._v("Has pane!")]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.tools.randomizer.first()) + "\n    " + _vm._s(_vm.tools.randomizer.last()) + "\n\n    "), _c('ui-button', {
    on: {
      "click": function () { return this$1.tools.changeView(); }
    }
  }, [_vm._v("Add breadcrumb")]), _vm._v(" "), _c('ui-button', {
    on: {
      "click": function () { return this$1.tools.changeView({
        key: 'info',
        title: ("Item #" + (Math.floor(Math.random() * 100))),
        data: {
          hasPane: true,
        }
      }); }
    }
  }, [_vm._v("Add item with pane")]), _vm._v(" "), _c('ui-button', {
    on: {
      "click": function () { return this$1.tools.changeView({
        key: 'basic-view',
        title: this$1.tools.randomizer.first(),
        data: {
          hasPane: false,
        }
      }); }
    }
  }, [_vm._v("Add item without pane")])], 1)
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'user') ? _c('div', {
    staticClass: "pane-template sticky-header"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.user.title,
      "subtitle": _vm.user.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.user.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('pane-content-with-sidebar', {
    attrs: {
      "updateWhenThisValueChanges": _vm.expandAll
    }
  }, [_c('pane-section', {
    attrs: {
      "id": "user-information",
      "title": "User information",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed(false)
    }
  }, [_c('ui-link', {
    on: {
      "click": _vm.toggleExpandAll
    },
    slot: "pane-header-right"
  }, [_vm._v(_vm._s(_vm.expandAll === false ? 'Collapse all' : 'Expand all'))]), _vm._v(" "), _c('ui-details', {
    staticClass: "no-padding",
    attrs: {
      "size": "p25",
      "list": [{
          label: 'Patron group',
          value: _vm.user.patron_group,
        },
        {
          label: 'Status',
          value: _vm.user.status,
        },
        {
          label: 'Expiration date',
          value: _vm.user.expiration_date,
        },
        {
          label: 'Username',
          value: _vm.user.username,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Extended Information",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Contact information",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 4
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Addresses",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 3
    }
  })], 1)], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "proxy",
      "title": "Proxy",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "fees-and-fines",
      "title": "Fees and fines",
      "itemCountMax": 4,
      "itemCountMin": 2,
      "preset": "fee",
      "includeInList": {
        user: _vm.user
      },
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('ui-button', {
    on: {
      "click": _vm.viewUserFees
    },
    slot: "pane-header-right"
  }, [_vm._v("View history")])], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "loans",
      "hasButton": false,
      "title": "Loans",
      "tools": _vm.tools,
      "isCollapsed": _vm.isCollapsed(false),
      "includeInList": {
        user: _vm.user
      }
    }
  }, [_c('ui-button', {
    on: {
      "click": _vm.viewUserLoans
    },
    slot: "pane-header-right"
  }, [_vm._v("View Loans")]), _vm._v(" "), _c('ui-link', {
    on: {
      "click": _vm.viewUserLoans
    }
  }, [_vm._v("Open loans")]), _c('br'), _vm._v(" "), _c('ui-link', {
    on: {
      "click": _vm.viewUserLoans
    }
  }, [_vm._v("Closed loans")])], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "communications",
      "title": "Communications",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "patron-groups",
      "title": "Patron groups",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1), _vm._v(" "), _c('pane-section', {
    attrs: {
      "id": "staff-permissions",
      "title": "Staff permissions",
      "tools": _vm.tools,
      "hasButton": false,
      "isCollapsed": _vm.isCollapsed()
    }
  }, [_c('ui-button', {
    slot: "pane-header-right"
  }, [_vm._v("Add permission")]), _vm._v(" "), _c('skeleton-lines', {
    attrs: {
      "lines": 20
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['scrollable-container', _vm.disabled ? 'disabled' : null]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'package') ? _c('div', {
    staticClass: "pane-template"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.package.title,
      "subtitle": _vm.package.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.package.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-details', {
    attrs: {
      "title": _vm.package.title,
      "list": [{
          label: 'Holdings',
          value: _vm.package.holdings,
        },
        {
          label: 'Type',
          value: _vm.package.type,
        },
        {
          label: 'Hide all titles in this package',
          value: _vm.package.hide_all_titles,
        },
        {
          label: 'Allow EBSCO to add new titles',
          value: _vm.package.allow_ebsco,
        },
        {
          label: 'Source',
          value: _vm.package.source,
        },
        {
          label: 'Titles',
          value: _vm.package.titles,
        },
        {
          label: 'Vendor',
          value: _vm.package.vendor,
        },
        {
          label: 'Proxy server',
          value: _vm.package.proxy_server,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related instances",
      "preset": "instance",
      "itemCount": _vm.package.instanceCount,
      "tools": _vm.tools
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pane-view', {
    attrs: {
      "tools": _vm.tools,
      "previewPaneClass": "pane-width-800"
    }
  }, [_c('template', {
    slot: "search-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Search and filter",
      "tools": _vm.tools,
      "hasCloseSearchIcon": true
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-search-field', {
    staticClass: "pane__search-bar",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Status",
      "items": ['Active', 'Inactive']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Patron Group",
      "items": _vm.patronGroups
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "results-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Users",
      "subtitle": "209 search results",
      "hasSearchIcon": true,
      "tools": _vm.tools,
      "appIconKey": "user"
    }
  }, [_c('ui-button', {
    attrs: {
      "title": "New",
      "iconLeft": "plus"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-data-list', {
    attrs: {
      "preset": "user",
      "type": "results",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "preview-pane"
  }, [_c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.visible) ? _c('button', {
    staticClass: "mode-switcher__toggle",
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "777",
      "height": "681",
      "viewBox": "0 0 777 681",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M209.662 0h357.68c11.007 0 21.212 5.857 26.67 15.414l178.872 309.688a30.917 30.917 0 0 1 0 30.826l-178.872 309.66C588.554 675.145 578.38 681 567.342 681h-357.68c-11.009 0-21.215-5.855-26.673-15.412L4.117 355.928a30.91 30.91 0 0 1 0-30.826L182.989 15.414C188.478 5.857 198.653 0 209.662 0zm178.839 155.585c-102.031 0-185.008 82.954-185.008 184.96 0 102.008 82.977 184.963 185.008 184.963 102.001 0 185.007-82.955 185.007-184.962 0-102.007-82.975-184.961-185.007-184.961z",
      "fill": "#FFF",
      "fill-rule": "nonzero"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['mode-switcher', _vm.visible ? 'visible' : '']
  }, [_c('transition', {
    attrs: {
      "name": "mode-switcher-vignette-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "mode-switcher__vignette",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mode-switcher-content-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "mode-switcher__content"
  }, [_c('button', {
    staticClass: "mode-switcher__close",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header large centered"
  }, [_vm._v("Prototype preferences")])]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__columns"
  }, [_c('div', {
    staticClass: "mode-switcher__content__columns__column"
  }, [_c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Preset")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPreset),
      expression: "currentPreset"
    }],
    staticClass: "mode-switcher__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentPreset = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.presets), function(preset) {
    return _c('option', {
      domProps: {
        "value": preset.value
      }
    }, [_vm._v("\n                                    " + _vm._s(preset.label) + "\n                                ")])
  })), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.advanced = !_vm.advanced
      }
    }
  }, [_vm._v(_vm._s(_vm.advanced ? 'Hide advanced options' : 'Show advanced options'))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mode-switcher__content__block border-top"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Demo")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/208475715",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.advanced) ? _c('div', {
    staticClass: "mode-switcher__content__columns__column"
  }, [_c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose universal navigation mode")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.availableModes), function(mode) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": mode.key === _vm.currentMode,
        "value": mode.key
      },
      on: {
        "change": function () { return _vm.onChangeMode(mode.key); }
      }
    }), _vm._v(" "), (mode.key === _vm.currentMode) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (mode.key !== _vm.currentMode) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (mode.image && false) ? _c('div', {
      staticClass: "mode-switcher__form-group__image large"
    }, [_c('img', {
      attrs: {
        "src": mode.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(mode.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(mode.description))])])])
  }))]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Alt-key action")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.altClickModes), function(mode) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": mode.key === _vm.currentAltClickMode,
        "value": mode.key
      },
      on: {
        "change": function () { return _vm.onChangeAltClickMode(mode.key); }
      }
    }), _vm._v(" "), (mode.key === _vm.currentAltClickMode) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (mode.key !== _vm.currentAltClickMode) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (mode.image && false) ? _c('div', {
      staticClass: "mode-switcher__form-group__image large"
    }, [_c('img', {
      attrs: {
        "src": mode.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(mode.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(mode.description))])])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('div', {
    staticClass: "mode-switcher__content__columns__column"
  }, [_c('div', {
    staticClass: "mode-switcher__content__block"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose back button layout")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.backButtonBehaviors), function(behavior) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": behavior.key === _vm.currentBackButtonBehavior,
        "value": behavior.key
      },
      on: {
        "change": function () { return _vm.onChangeBackButtonBehavior(behavior.key); }
      }
    }), _vm._v(" "), (behavior.key === _vm.currentBackButtonBehavior) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (behavior.key !== _vm.currentBackButtonBehavior) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (behavior.image && false) ? _c('div', {
      staticClass: "mode-switcher__form-group__image small"
    }, [_c('img', {
      attrs: {
        "src": behavior.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(behavior.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(behavior.description))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__block border-top"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose context switcher layout")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.switcherLayouts), function(switcherLayout) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": switcherLayout.key === _vm.currentSwitcherLayout,
        "value": switcherLayout.key
      },
      on: {
        "change": function () { return _vm.onChangeSwitcherLayout(switcherLayout.key); }
      }
    }), _vm._v(" "), (switcherLayout.key === _vm.currentSwitcherLayout) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (switcherLayout.key !== _vm.currentBackButtonBehavior) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (switcherLayout.image) ? _c('div', {
      staticClass: "mode-switcher__form-group__image small"
    }, [_c('img', {
      attrs: {
        "src": switcherLayout.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(switcherLayout.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(switcherLayout.description))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__content__block border-top"
  }, [_c('h3', {
    staticClass: "mode-switcher__content__block__header"
  }, [_vm._v("Choose \"Show all\" behavior\"")]), _vm._v(" "), _c('div', {
    staticClass: "mode-switcher__form-groups"
  }, _vm._l((_vm.showAllBehaviors), function(showAllBehavior) {
    return _c('label', {
      staticClass: "mode-switcher__form-group"
    }, [_c('div', {
      staticClass: "mode-switcher__form-group__radio"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "mode"
      },
      domProps: {
        "checked": showAllBehavior.key === _vm.currentShowAllBehavior,
        "value": showAllBehavior.key
      },
      on: {
        "change": function () { return _vm.onChangeShowAllBehavior(showAllBehavior.key); }
      }
    }), _vm._v(" "), (showAllBehavior.key === _vm.currentShowAllBehavior) ? _c('div', {
      staticClass: "mode-switcher__form-group__icon mode-switcher__form-group__icon__selected"
    }, [_c('i', {
      class: ['fa', 'outer', 'fa-circle']
    }), _vm._v(" "), _c('i', {
      class: ['fa', 'inner', 'fa-circle']
    })]) : _vm._e(), _vm._v(" "), (showAllBehavior.key !== _vm.currentShowAllBehavior) ? _c('i', {
      class: ['fa', 'mode-switcher__form-group__icon', 'fa-circle']
    }) : _vm._e()]), _vm._v(" "), (showAllBehavior.image) ? _c('div', {
      staticClass: "mode-switcher__form-group__image small"
    }, [_c('img', {
      attrs: {
        "src": showAllBehavior.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mode-switcher__form-group__content"
    }, [_c('h4', [_vm._v(_vm._s(showAllBehavior.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(showAllBehavior.description))])])])
  }))])]) : _vm._e()])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-details"
  }, [_c('ui-headline', [_vm._v(_vm._s(_vm.order.headline))]), _vm._v(" "), _c('section', {
    staticClass: "order-details--top"
  }, [_c('section', {
    staticClass: "order-details--img"
  }), _vm._v(" "), _c('section', {
    staticClass: "order-details--info"
  }, [_c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Order: ")]), _vm._v(" "), _c('section', {}, [_vm._v(_vm._s(_vm.order.name))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Created: ")]), _vm._v(" "), _c('section', {}, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Sent: ")]), _vm._v(" "), _c('section', {}, [_vm._v(" " + _vm._s(_vm.order.sent))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("User: ")]), _vm._v(" "), _c('section', {}, [_vm._v(_vm._s(_vm.order.user))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attribute"
  }, [_c('span', [_vm._v("Vendor:")]), _vm._v(" "), _c('select', [_c('option', {
    attrs: {
      "value": "choice"
    }
  }, [_vm._v(_vm._s(_vm.order.vendor) + " - $00.00")])])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Fund Distribution:")]), _vm._v(" "), _c('section', {
    staticClass: "order-details--scrollbox"
  }, [_c('ui-checklist', {
    attrs: {
      "items": ['Medical', 'History', 'Arts', 'Engineering']
    }
  })], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', {
    staticClass: "order-details--totalpricesection"
  }, [_c('section', {
    staticClass: "order-details--totalprice"
  }, [_vm._v(_vm._s(_vm.order.price))]), _vm._v(" "), _c('section', {
    staticClass: "order-details--label"
  }, [_vm._v("Total price")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', {
    staticClass: "order-details--buttons"
  }, [_c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Send"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Reorder"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Cancel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Edit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Delete"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-details--checkedboxes"
  }, [_c('section', {
    staticClass: "order-details--checkedbox__percentage"
  }, [_vm._v("Medical %")]), _vm._v(" "), _c('section', {
    staticClass: "order-details--checkedbox__percentage"
  }, [_vm._v("Engineering %")])])
}]}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "pane-header"
  }, [_vm._t("default", [_c('section', {
    staticClass: "pane-header__section--left"
  }, [(_vm.showBackButton) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": _vm.tools.navigate.goBack
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M15.5,19.75c-0.192,0-0.384-0.073-0.53-0.22l-7-7c-0.293-0.293-0.293-0.768,0-1.061l7-7c0.293-0.293,0.768-0.293,1.061,0\n\t\tc0.293,0.293,0.293,0.768,0,1.061L9.56,12l6.47,6.47c0.293,0.293,0.293,0.768,0,1.061C15.884,19.676,15.692,19.75,15.5,19.75z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), (_vm.showCloseButton) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": _vm.tools.navigate.goBack
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Close")])]) : _vm._e(), _vm._v(" "), (_vm.hasCloseSearchIcon) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": function () { return _vm.tools.actions.togglePane('search'); }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.hasCloseIcon) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": function () { return _vm.tools.actions.closePreviewPane(); }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.hasSearchIcon) ? _c('button', {
    staticClass: "pane-header-button left",
    on: {
      "click": function () { return _vm.tools.actions.togglePane('search'); }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.707,18.293l-4.049-4.048c1.838-2.521,1.628-6.081-0.647-8.355c-2.515-2.515-6.607-2.515-9.123,0\n\tc-2.515,2.515-2.515,6.608,0,9.123c1.258,1.258,2.91,1.886,4.562,1.886c1.335,0,2.667-0.418,3.793-1.239l4.049,4.048\n\tC18.488,19.902,18.744,20,19,20s0.512-0.098,0.707-0.293C20.098,19.316,20.098,18.683,19.707,18.293z M7.303,13.598\n\tc-1.735-1.735-1.735-4.56,0-6.295c0.868-0.868,2.007-1.301,3.147-1.301c1.14,0,2.279,0.434,3.147,1.301\n\tc1.735,1.735,1.735,4.56,0,6.295C11.862,15.333,9.039,15.333,7.303,13.598z"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), _c('section', {
    staticClass: "pane-header__section--center"
  }, [_c('section', {
    staticClass: "pane-header__title"
  }, [(_vm.appIconKey) ? _c('app-icon', {
    attrs: {
      "tools": _vm.tools,
      "name": _vm.appIconKey
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title", [_vm._v(_vm._s(_vm.title))], {
    tag: "span"
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "pane-header__subtitle"
  }, [_vm._t("subtitle", [_vm._v(_vm._s(_vm.subtitle))], {
    tag: "span"
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "pane-header__section--right"
  }, [_vm._t("right")], 2)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.414,12l4.302-4.302c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L12,10.586L7.698,6.284\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L10.586,12l-4.302,4.302c-0.391,0.391-0.391,1.023,0,1.414\n                    c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L12,13.414l4.302,4.302c0.195,0.195,0.451,0.293,0.707,0.293\n                    s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L13.414,12z"
    }
  })])
}]}

/***/ })
],[173]);


// WEBPACK FOOTER //
// static/js/app.15386762987ab6631ab7.js